package com.downdogapp.client

import com.downdogapp.client.api.Language.*
import com.downdogapp.client.singleton.Key
import com.downdogapp.client.singleton.UserPrefs

/**
 * AUTO-GENERATED DO NOT EDIT!
 * from com.downdogapp.tasks.AppStrings
 */
// @formatter:off
object Strings {

  val language get() =
    if (manifestInitialized())
      MANIFEST.languageOptions.find { it.value.name == UserPrefs[Key.Language] }?.value
      ?: MANIFEST.defaultLanguage
    else
      ENGLISH

  private val languageStringFile get() = when (language) {
    ENGLISH -> EnglishStrings
    FRENCH -> FrenchStrings
    GERMAN -> GermanStrings
    ITALIAN -> ItalianStrings
    JAPANESE -> JapaneseStrings
    KOREAN -> KoreanStrings
    MANDARIN -> MandarinStrings
    POLISH -> PolishStrings
    PORTUGUESE -> PortugueseStrings
    RUSSIAN -> RussianStrings
    SPANISH -> SpanishStrings
    TURKISH -> TurkishStrings
    UKRAINIAN -> UkrainianStrings
  }

  // https://worker.downdogapp.com/debug/appString?appStringId=488
  // Canceled, expiring {1}
  fun ABBREVIATED_MEMBERSHIP_WILL_NOT_RENEW(p0: Any) = languageStringFile.ABBREVIATED_MEMBERSHIP_WILL_NOT_RENEW(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=498
  // Account
  val ACCOUNT get() = languageStringFile.ACCOUNT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2588
  // Looks like you already have an account!  Only new accounts are eligible for free membership from referral.  Sorry!
  val ACCOUNT_INELIGIBLE_FOR_REFERRAL_MESSAGE get() = languageStringFile.ACCOUNT_INELIGIBLE_FOR_REFERRAL_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1467
  // Thank you for your interest!  We have discontinued our affiliate program, so unfortunately not.  Sorry!
  val AFFILIATE_ANSWER get() = languageStringFile.AFFILIATE_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1466
  // Do you have a referral or affiliate program?
  val AFFILIATE_QUESTION get() = languageStringFile.AFFILIATE_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1299
  // Affordability
  val AFFORDABILITY get() = languageStringFile.AFFORDABILITY
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1300
  // Tell us about your situation
  val AFFORDABILITY_FEEDBACK_PROMPT get() = languageStringFile.AFFORDABILITY_FEEDBACK_PROMPT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=518
  // Our mission is to provide great affordable fitness to the world. If Down Dog isn't in your budget right now, send us a message explaining your situation and we'll see what we can do!
  val AFFORDABILITY_MESSAGE get() = languageStringFile.AFFORDABILITY_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3950
  // Airplay
  val AIRPLAY get() = languageStringFile.AIRPLAY
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1409
  // You can AirPlay your Down Dog practice using screen mirroring! For more information, go to <a href="https://support.apple.com/en-us/HT204289">Apple's support page</a>
  val AIRPLAY_ANSWER get() = languageStringFile.AIRPLAY_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1408
  // Do you support AirPlay?
  val AIRPLAY_QUESTION get() = languageStringFile.AIRPLAY_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1292
  // All
  val ALL get() = languageStringFile.ALL
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1255
  // All Apps
  val ALL_APPS get() = languageStringFile.ALL_APPS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1453
  // At this time, subscription purchases give you access to all of our apps, including Down Dog Yoga, HIIT, Barre, Prenatal Yoga, and Meditation! 
  // 
  // We do not currently offer the option to purchase a single app.
  val ALL_APPS_PURCHASE_ANSWER get() = languageStringFile.ALL_APPS_PURCHASE_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1452
  // Is my subscription for one app or all apps?
  val ALL_APPS_PURCHASE_QUESTION get() = languageStringFile.ALL_APPS_PURCHASE_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3110
  // All Poses
  val ALL_POSES get() = languageStringFile.ALL_POSES
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1295
  // All amounts shown in {1}. Your payment data is encrypted and secure.
  // 
  fun AMOUNTS_CURRENCY_PAYMENTS_SECURE_MESSAGE(p0: Any) = languageStringFile.AMOUNTS_CURRENCY_PAYMENTS_SECURE_MESSAGE(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=113
  // and
  val AND get() = languageStringFile.AND
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1589
  // Apple
  val APPLE get() = languageStringFile.APPLE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1403
  // Yes!  If you are having trouble connecting, here are some tips:
  // 1. Check that your app is connected to Health.  Open the app and navigate to the menu (hit the three horizontal lines button in bottom right), is there an option to Connect To Apple Health?  If so, click that option.
  // 2. Open the Health App on your phone, and click the data sources tab.  Is Down Dog listed as a data source?  This is to double check Down Dog is connected.  If it isn't (but there was no option to connect within Down Dog), let us know!
  // 3. Try uninstalling and reinstalling the app, and then logging in and reconnecting to Apple Health.
  // 
  // Unfortunately, Apple Health isn't supported on iPad, and we don't support tracking your practices across devices (although we may some day).
  val APPLE_HEALTH_ANSWER get() = languageStringFile.APPLE_HEALTH_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1402
  // Do the apps connect to Apple Health?
  val APPLE_HEALTH_QUESTION get() = languageStringFile.APPLE_HEALTH_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1420
  // Unfortunately, Apple doesn't let us cancel or refund subscriptions that were purchased through the App Store. Here's some instructions from Apple for how to cancel your subscription: {1}
  fun APPLE_REFUND_POLICY(p0: Any) = languageStringFile.APPLE_REFUND_POLICY(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1425
  // Ask in the Facebook group
  val ASK_IN_FACEBOOK_GROUP get() = languageStringFile.ASK_IN_FACEBOOK_GROUP
  
  // https://worker.downdogapp.com/debug/appString?appStringId=490
  // Auto-Renew Off
  val AUTO_RENEW_IS_OFF get() = languageStringFile.AUTO_RENEW_IS_OFF
  
  // https://worker.downdogapp.com/debug/appString?appStringId=489
  // Auto-Renew On
  val AUTO_RENEW_IS_ON get() = languageStringFile.AUTO_RENEW_IS_ON
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1221
  // <b>How to Manage or Cancel Your Subscription</b>
  // 
  // If you purchased your subscription <em>on the web</em>:
  // 1. Go to <b>Settings</b>. On mobile, you can get there by tapping the three horizontal lines at the bottom right of the screen. On web, Settings is in the left sidebar. 
  // 2. Under <b>Settings</b>, tap <b>Subscription</b>.
  // 3. Then you should see more info, including how to cancel or change your subscription, including turning off auto-renew.
  // 
  // If you purchased your subscription <em>through the mobile app</em> you can manage your subscription through the <a href="https://support.apple.com/en-us/HT202039" target="_blank">Apple App Store</a> or through the <a href="https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en" target="_blank">Google Play Store</a>. 
  // 
  // <b>About Your Subscription</b>
  // 
  // You will never be charged for a subscription unless you explicitly purchase a membership through our website, Apple, or Google. Subscriptions are found under the email address that you used when you purchased the subscription. If you do not see a subscription listed in your account, it means you do not have a subscription associated with the email address you currently logged in with. It is possible that your subscription may be associated with another email address, and if that is the case, you will need to log out and then log back in under that email address to see your subscription.
  // 
  val AUTO_RENEW_OFF_ANSWER get() = languageStringFile.AUTO_RENEW_OFF_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1211
  // I want to disable auto-renew.
  val AUTO_RENEW_OFF_QUESTION get() = languageStringFile.AUTO_RENEW_OFF_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=252
  // Back
  val BACK get() = languageStringFile.BACK
  
  // https://worker.downdogapp.com/debug/appString?appStringId=787
  // Barre
  val BARRE get() = languageStringFile.BARRE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=759
  // Barre Workout
  val BARRE_GOOGLE_FIT_DESCRIPTION get() = languageStringFile.BARRE_GOOGLE_FIT_DESCRIPTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1432
  // Billling
  val BILLING get() = languageStringFile.BILLING
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1258
  // Billing - refund
  val BILLING_REFUND get() = languageStringFile.BILLING_REFUND
  
  // https://worker.downdogapp.com/debug/appString?appStringId=332
  // Breathing
  val BREATHING get() = languageStringFile.BREATHING
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2538
  // Breathwork Practice
  val BREATHING_GOOGLE_FIT_DESCRIPTION get() = languageStringFile.BREATHING_GOOGLE_FIT_DESCRIPTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=263
  // Cancel
  val CANCEL get() = languageStringFile.CANCEL
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2564
  // Cancel Download
  val CANCEL_DOWNLOAD get() = languageStringFile.CANCEL_DOWNLOAD
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1470
  // Unfortunately, we cannot merge your accounts. 
  // 
  // Please make sure to sign in with the email you used when purchasing your subscription to get access!
  val CANNOT_MERGE_ACCOUNTS_ANSWER get() = languageStringFile.CANNOT_MERGE_ACCOUNTS_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1469
  // I have more than one account. Can I merge them?
  val CANNOT_MERGE_ACCOUNTS_QUESTION get() = languageStringFile.CANNOT_MERGE_ACCOUNTS_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1305
  // You likely created multiple Down Dog accounts by accident. You should try logging out of the app and logging back in with any other email addresses you may have used. Please note that your subscription works across all of our apps and on all of your devices (including the web version), but you must be signed in with the same email you used to make the purchase. <em>Note that Apple, Google, and PayPal may have sent receipts to the email address you have associated with those services, and not the email address you used to log into Down Dog</em>.
  // 
  // If you subscribed from within the mobile app using Apple iTunes or Google Play, you should try clicking <b>Restore In-App Purchase</b> from the menu of the app. Be sure to do this from within the same app in which you made the original purchase.
  // 
  // If you subscribed via PayPal and you don't have access to your subscription, your payment most likely did not succeed. You can check this from within your PayPal account, or by visiting the Settings of the app where you will see a subscription that only lasts a few days. If this is the case, you were not actually charged and you can attempt to make the purchase again by visiting our website. You may have more success paying with a credit card directly rather than using PayPal.
  // 
  val CANT_ACCESS_SUBSCRIPTION_ANSWER get() = languageStringFile.CANT_ACCESS_SUBSCRIPTION_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1304
  // I can't access my subscription.
  val CANT_ACCESS_SUBSCRIPTION_QUESTION get() = languageStringFile.CANT_ACCESS_SUBSCRIPTION_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3949
  // Cast
  val CAST get() = languageStringFile.CAST
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1203
  // Yes, we recently added Chromecast support in the mobile and web apps!
  // 
  // Here's how to use Chromecast in the mobile app: 
  // 1. Make sure your chromecast-enabled device (such as a TV) is turned on and is on the same WiFi network as your Android/iOS device, and also make sure you have the latest version of the app. 
  // 2. Start a practice. 
  // 3. Tap the screen to bring up the controls, then tap the <b>Chromecast button</b> in the top right (it looks like a rectangle with three quarter-circles in the bottom corner). 
  // 4. Wait up to a minute for the practice to load on your TV, then click play on your Android/iOS device. 
  // 
  // And here's how to use Chromecast on the web app: 
  // 1. Make sure your chromecast-enabled device (such as a TV) is turned on and is on the same WiFi network as your computer. 
  // 2. Start a practice in the web app, using <b>Chrome</b>. 
  // 3. Click the <b>Chromecast button</b> in the bottom right (iIt looks like a rectangle with three quarter-circles in the bottom corner). 
  // 4. Wait up to a minute for the practice to load on your TV, then click play on your computer.
  val CAST_ANSWER get() = languageStringFile.CAST_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1191
  // Do you support Chromecast?
  val CAST_QUESTION get() = languageStringFile.CAST_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1349
  // <b>If your CAST BUTTON is not showing up:</b> 
  // 
  // 1. Start a practice, then pause. Do you see the cast button (top right corner for Android/iOS; bottom right corner for the web app)? We only show the cast button during a practice. 
  // 
  // 2. Try casting something else (e.g. YouTube) from the same device. Do you see a cast button then? If not, make sure your chromecast-enabled device (such as a TV) is turned on and is on the same WiFi network as your computer or your Android/iOS device. If you're on a computer, make sure you're using Chrome. 
  // 
  // 3. Try casting from a different device. If you were using Android/iOS, try casting from the web app on your computer, and vice versa. 
  // 
  // 4. Try turning off battery optimization for the Down Dog app(s) on your phone. This will let the app keep communicating with your Chromecast device, instead of going into power saving mode after a few minutes of inactivity. 
  // 
  // 
  // <b>If you're "CONNECTED" but the video doesn't play:</b> 
  // 
  // First, make sure that you're waiting long enough for Down Dog to load on your TV. Loading can take up to 60 seconds. During this time your TV will initially show a yellow "loading" bar across the bottom, then fade to black. Your TV will show the video once it has finished loading. 
  // 
  // If your TV screen is still black after 60 seconds, or if the words "Down Dog" appear in the middle of a black screen, exit your practice and try again. You can restart the same practice from the History tab (the clock icon at the bottom of your screen for Android/iOS; in the left sidebar for web). 
  // 
  // 
  // <b>If your cast DISCONNECTS after a few minutes of playback:</b> 
  // 
  // 1. Check your WiFi signal strength. If your Chromecast or phone/computer has a weak signal, you can improve the signal strength using a WiFi extender or by moving it closer to your router.
  // 
  // 2. Turn off battery optimization for the Down Dog app(s) on your phone. This will let the app keep communicating with your Chromecast device, instead of going into power saving mode after a few minutes of inactivity. 
  // 
  // 3. If that doesn't fix the issue, you can also try restarting your router.
  // 
  // 4. Finally, try editing your phone's stored wifi connection settings to use a static IP address.
  // 
  val CAST_TROUBLESHOOTING_ANSWER get() = languageStringFile.CAST_TROUBLESHOOTING_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1348
  // I'm having trouble with Chromecast.
  val CAST_TROUBLESHOOTING_QUESTION get() = languageStringFile.CAST_TROUBLESHOOTING_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=997
  // Casting to {1}
  fun CASTING_TO_DEVICE(p0: Any) = languageStringFile.CASTING_TO_DEVICE(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3302
  // Email
  val CHALLENGE_EMAIL_NOTIFICATIONS_TEXT get() = languageStringFile.CHALLENGE_EMAIL_NOTIFICATIONS_TEXT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3470
  // Email
  val CHALLENGE_EMAIL_UPDATES_TEXT get() = languageStringFile.CHALLENGE_EMAIL_UPDATES_TEXT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3468
  // Challenge Updates
  val CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBHEADER get() = languageStringFile.CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBHEADER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3469
  // Get updates on the community and your challenge progress!
  val CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBTEXT get() = languageStringFile.CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBTEXT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3466
  // Daily Reminders
  val CHALLENGE_ENROLL_DAILY_REMINDERS_SUBHEADER get() = languageStringFile.CHALLENGE_ENROLL_DAILY_REMINDERS_SUBHEADER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3467
  // Get reminders to practice every day in January!
  val CHALLENGE_ENROLL_DAILY_REMINDERS_SUBTEXT get() = languageStringFile.CHALLENGE_ENROLL_DAILY_REMINDERS_SUBTEXT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3809
  // A: To complete the challenge, you must complete a practice every day of the month. You can use any Down Dog app. Practices must be completed in full.
  val CHALLENGE_FAQ_A1 get() = languageStringFile.CHALLENGE_FAQ_A1
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3811
  // A: Down Dog will track your progress using the calendar on the Journey page of your app! Every day when you practice and you see the calendar date in blue, it is tracked towards your challenge progress. 
  val CHALLENGE_FAQ_A2 get() = languageStringFile.CHALLENGE_FAQ_A2
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3814
  // A: We send our daily reminders based on the time you practiced the day before. So if you practiced earlier than you normally would you may have beat us to it! As long as you see your practices tracked on the calendar on your Journey page they count towards your challenge progress.
  val CHALLENGE_FAQ_A3 get() = languageStringFile.CHALLENGE_FAQ_A3
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3816
  // A: No. We’re very sorry but we can’t add practices to your history that were not completed on a Down Dog app.
  val CHALLENGE_FAQ_A4 get() = languageStringFile.CHALLENGE_FAQ_A4
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3818
  // A: If you're traveling and changing time zones, this might affect your challenge streak. Currently, our system records your practice history based on the time zone you're in at the time of practice. This means your practice dates will align with your current time zone, not your original one. To maintain your streak, we recommend practicing at a time that aligns with your original time zone whenever possible.
  val CHALLENGE_FAQ_A5 get() = languageStringFile.CHALLENGE_FAQ_A5
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3820
  // A: Winners are selected randomly from the group of users who complete the challenge. Winners are contacted individually at the end of the challenge. 
  val CHALLENGE_FAQ_A6 get() = languageStringFile.CHALLENGE_FAQ_A6
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3808
  // Q: What are the requirements? 
  val CHALLENGE_FAQ_Q1 get() = languageStringFile.CHALLENGE_FAQ_Q1
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3810
  // Q: How is my progress tracked? 
  val CHALLENGE_FAQ_Q2 get() = languageStringFile.CHALLENGE_FAQ_Q2
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3813
  // Q: I am signed up for daily notifications but didn’t get one today, is something wrong? 
  val CHALLENGE_FAQ_Q3 get() = languageStringFile.CHALLENGE_FAQ_Q3
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3815
  // Q: I completed a practice somewhere else - can it be added to my app history? 
  val CHALLENGE_FAQ_Q4 get() = languageStringFile.CHALLENGE_FAQ_Q4
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3817
  // Q: I’m traveling during the challenge. Will that affect anything? 
  val CHALLENGE_FAQ_Q5 get() = languageStringFile.CHALLENGE_FAQ_Q5
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3819
  // Q: How are merch winners selected & contacted?
  val CHALLENGE_FAQ_Q6 get() = languageStringFile.CHALLENGE_FAQ_Q6
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3807
  // Down Dog Challenge FAQ
  val CHALLENGE_FAQ_TITLE get() = languageStringFile.CHALLENGE_FAQ_TITLE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3465
  // You've chosen not to receive any communications, so you won't receive any progress updates or reminders from Down Dog about the challenge.
  val CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TEXT get() = languageStringFile.CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TEXT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3471
  // Are you sure?
  val CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TITLE get() = languageStringFile.CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TITLE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3303
  // Push Notifications
  val CHALLENGE_PUSH_NOTIFICATIONS_TEXT get() = languageStringFile.CHALLENGE_PUSH_NOTIFICATIONS_TEXT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3317
  // Heads up!  You previously opted out of receiving email communications from Down Dog.  By enabling email communication within the challenge, we will automatically re-enable your account to receive email communications from us.
  val CHALLENGE_RESUBSCRIBE_TO_EMAILS_ALERT_TEXT get() = languageStringFile.CHALLENGE_RESUBSCRIBE_TO_EMAILS_ALERT_TEXT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1218
  // 1. Go to <b>Settings</b>. On mobile, you can get there by tapping the three horizontal lines at the bottom right of the screen. On web, Settings is in the left sidebar. 
  // 2. Under <b>Account</b>, tap <b>Email</b> and fill in the email you'd like to use
  // 3. Tap <b>Save</b>
  val CHANGE_EMAIL_ANSWER get() = languageStringFile.CHANGE_EMAIL_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1208
  // How do I change the email associated with my account?
  val CHANGE_EMAIL_QUESTION get() = languageStringFile.CHANGE_EMAIL_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=152
  // Change Language
  val CHANGE_LANGUAGE get() = languageStringFile.CHANGE_LANGUAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1159
  // <b>Yoga, Prenatal, Meditation, HIIT</b>
  // 
  // You can change the language by navigating to <b>Settings</b> (on the mobile app, tap the 3 horizontal lines in the bottom right, and on the web app Settings will be on the left sidebar) and then tap <b>Language</b>! 
  // 
  // <b>Barre</b>
  // 
  // Currently this app is only offered in English. You'll still hear instructions in English even after changing the language.
  val CHANGE_LANGUAGE_ANSWER get() = languageStringFile.CHANGE_LANGUAGE_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=327
  // Uh oh! You need to be connected to the internet in order to change your language.
  val CHANGE_LANGUAGE_NO_INTERNET_MESSAGE get() = languageStringFile.CHANGE_LANGUAGE_NO_INTERNET_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1158
  // How do I change the language I hear?
  val CHANGE_LANGUAGE_QUESTION get() = languageStringFile.CHANGE_LANGUAGE_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1219
  // 1. Go to <b>Settings</b>. On mobile, you can get there by tapping the three horizontal lines at the bottom right of the screen. On web, Settings is in the left sidebar. 
  // 2. Under <b>Account</b>, tap <b>Password</b> and fill in the new password you'd like to use in the Password and Confirm Password fields 
  // 3. Tap <b>Save</b>
  // 
  // If you have forgotten your password, just enter your email and an incorrect password at the login screen.  Then, click the <b>Forgot Password?</b> option.
  val CHANGE_PASSWORD_ANSWER get() = languageStringFile.CHANGE_PASSWORD_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1209
  // How do I change my password?
  val CHANGE_PASSWORD_QUESTION get() = languageStringFile.CHANGE_PASSWORD_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1142
  // We offer many categories of music and are constantly adding new options!  In the app, you can switch the music style by swiping up the settings view and tapping <b>Music</b>!  On the web version, you can scroll through the settings and click the <b>Music</b> option.
  val CHANGE_PLAYLIST_TYPE_ANSWER get() = languageStringFile.CHANGE_PLAYLIST_TYPE_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1141
  // How do I change the music?
  val CHANGE_PLAYLIST_TYPE_QUESTION get() = languageStringFile.CHANGE_PLAYLIST_TYPE_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=52
  // Uh oh! You'll need an internet connection to change the visuals for this practice.
  val CHANGE_VISUAL_TYPE_NO_INTERNET_MESSAGE get() = languageStringFile.CHANGE_VISUAL_TYPE_NO_INTERNET_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1157
  // <b>Yoga, Prenatal, Meditation, and HIIT</b>
  // 
  // We currently offer multiple English-speaking voices in these apps.  On mobile, you can change the voice you hear by swiping up on the main settings page, and then tapping on <b>Voice</b>.  On web, you can scroll through the settings and click the <b>Voice</b> option.
  // 
  // We also offer several non-English speaking voices in these apps.  You can change the language by navigating to <b>Settings</b> (on the mobile app, tap the 3 horizontal lines in the bottom right, and on the web app Settings will be on the left sidebar) and then tap <b>Language</b>!
  // 
  // <b>Barre</b>
  // 
  // There's only one voice for now, but we plan to add additional languages and voices in the future. 
  val CHANGE_VOICE_ANSWER get() = languageStringFile.CHANGE_VOICE_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1156
  // How do I change the voice I hear?
  val CHANGE_VOICE_QUESTION get() = languageStringFile.CHANGE_VOICE_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1441
  // I was charged twice.
  val CHARGED_TWICE get() = languageStringFile.CHARGED_TWICE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1433
  // Check out our {1} to see if your question is answered there
  fun CHECK_OUT_QUESTION(p0: Any) = languageStringFile.CHECK_OUT_QUESTION(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=482
  // Are you sure you want to delete all practices from your practice history? This action cannot be undone.
  val CLEAR_PRACTICE_HISTORY_CONFIRM_MESSAGE get() = languageStringFile.CLEAR_PRACTICE_HISTORY_CONFIRM_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=275
  // Close
  val CLOSE get() = languageStringFile.CLOSE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1180
  // We have a vibrant and supportive <a href="https://www.facebook.com/groups/183894272193568/" target="_blank">Down Dog Community</a> on Facebook that you can join to ask for advice and share your progress!  You can also follow us on <a href="https://www.instagram.com/downdogapp/" target="_blank">Instagram</a> to get tips and connect with others who practice with Down Dog!
  val COMMUNITY_ANSWER get() = languageStringFile.COMMUNITY_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1172
  // I’m craving community during my journey!  Is there some group I can join to support me when I have questions?
  val COMMUNITY_QUESTION get() = languageStringFile.COMMUNITY_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1394
  // Work-from-home employees are eligible for free membership through June 1st!
  val COMPANIES_FREE_UNTIL_JUNE_1_LONG get() = languageStringFile.COMPANIES_FREE_UNTIL_JUNE_1_LONG
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2563
  // Are you sure you want to cancel this download?
  val CONFIRM_CANCEL_OFFLINE_DOWNLOAD get() = languageStringFile.CONFIRM_CANCEL_OFFLINE_DOWNLOAD
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2561
  // Are you sure you want to delete this offline practice?
  val CONFIRM_DELETE_OFFLINE_PRACTICE get() = languageStringFile.CONFIRM_DELETE_OFFLINE_PRACTICE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=428
  // Confirm Password
  val CONFIRM_PASSWORD get() = languageStringFile.CONFIRM_PASSWORD
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1
  // Connect to Apple Health
  val CONNECT_TO_APPLE_HEALTH get() = languageStringFile.CONNECT_TO_APPLE_HEALTH
  
  // https://worker.downdogapp.com/debug/appString?appStringId=93
  // Connect to Google Fit
  val CONNECT_TO_GOOGLE_FIT get() = languageStringFile.CONNECT_TO_GOOGLE_FIT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2
  // Your practices will now automatically be logged to Apple Health!
  val CONNECTED_TO_APPLE_HEALTH_MESSAGE get() = languageStringFile.CONNECTED_TO_APPLE_HEALTH_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=94
  // Your practices will now automatically be logged to Google Fit!
  val CONNECTED_TO_GOOGLE_FIT_MESSAGE get() = languageStringFile.CONNECTED_TO_GOOGLE_FIT_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1009
  // Connecting...
  val CONNECTING_TO_CHROMECAST get() = languageStringFile.CONNECTING_TO_CHROMECAST
  
  // https://worker.downdogapp.com/debug/appString?appStringId=25
  // Connection Problem
  val CONNECTION_PROBLEM get() = languageStringFile.CONNECTION_PROBLEM
  
  // https://worker.downdogapp.com/debug/appString?appStringId=264
  // Contact
  val CONTACT get() = languageStringFile.CONTACT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1421
  // If you want a refund, you should contact Apple support and let them know that we are okay with a refund. 
  val CONTACT_APPLE_FOR_REFUND get() = languageStringFile.CONTACT_APPLE_FOR_REFUND
  
  // https://worker.downdogapp.com/debug/appString?appStringId=265
  // Continue
  val CONTINUE get() = languageStringFile.CONTINUE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=437
  // Corporate Membership
  val CORPORATE_MEMBERSHIP get() = languageStringFile.CORPORATE_MEMBERSHIP
  
  // https://worker.downdogapp.com/debug/appString?appStringId=616
  // Countdown Timer
  val COUNTDOWN_TIMER get() = languageStringFile.COUNTDOWN_TIMER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2550
  // Create Offline Practice
  val CREATE_OFFLINE_PRACTICE get() = languageStringFile.CREATE_OFFLINE_PRACTICE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2562
  // Create and download a practice with your current settings?
  val CREATE_OFFLINE_PRACTICE_EXPLANATION get() = languageStringFile.CREATE_OFFLINE_PRACTICE_EXPLANATION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1604
  // Custom
  val CUSTOM get() = languageStringFile.CUSTOM
  
  // https://worker.downdogapp.com/debug/appString?appStringId=266
  // Delete
  val DELETE get() = languageStringFile.DELETE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=399
  // Delete Account
  val DELETE_ACCOUNT get() = languageStringFile.DELETE_ACCOUNT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=487
  // Your account will be PERMANENTLY deleted for ALL of the Down Dog apps, and we will automatically cancel your subscription. Continue?
  val DELETE_ACCOUNT_AND_STOP_PAYMENTS_CONFIRM_MESSAGE get() = languageStringFile.DELETE_ACCOUNT_AND_STOP_PAYMENTS_CONFIRM_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1220
  // Should you decide to leave us, you can delete your account on the mobile app or on the web app. Please note that once your account is deleted, you will lose your paid subscription as well as your history and saved practices and it cannot be restored!
  // 
  // 1. Go to <b>Settings</b>. On mobile, you can get there by tapping the three horizontal lines at the bottom right of the screen. On web, Settings is in the left sidebar. 
  // 2. Under <b>Settings</b>, scroll down to <b>My Data</b>, and tap <b>Delete Account</b>.
  // 3. When prompted by the pop up box, tap <b>OK</b>.
  val DELETE_ACCOUNT_ANSWER get() = languageStringFile.DELETE_ACCOUNT_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=485
  // Are you sure you want to delete your account? This action cannot be undone. Your account will be permanently deleted for all of the Down Dog apps.
  val DELETE_ACCOUNT_CONFIRM_MESSAGE get() = languageStringFile.DELETE_ACCOUNT_CONFIRM_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1210
  // How do I delete my account?
  val DELETE_ACCOUNT_QUESTION get() = languageStringFile.DELETE_ACCOUNT_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1556
  // You are about to permanently delete your account for ALL Down Dog apps. THIS ACTION CANNOT BE UNDONE. Do you want to continue?
  val DELETE_ACCOUNT_RECONFIRM_MESSAGE get() = languageStringFile.DELETE_ACCOUNT_RECONFIRM_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=486
  // Your account will be permanently deleted for ALL of the Down Dog apps. You will STILL BE CHARGED for your subscription until you cancel it. Continue?
  val DELETE_ACCOUNT_WITHOUT_STOPPING_PAYMENTS_CONFIRM_MESSAGE get() = languageStringFile.DELETE_ACCOUNT_WITHOUT_STOPPING_PAYMENTS_CONFIRM_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=467
  // Clear Practice History
  val DELETE_HISTORY get() = languageStringFile.DELETE_HISTORY
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2565
  // Delete Offline Practice
  val DELETE_OFFLINE_PRACTICE get() = languageStringFile.DELETE_OFFLINE_PRACTICE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1351
  // Yes! Make sure to use the same email to log in that you used when you subscribed.
  val DEVICE_LIMIT_ANSWER get() = languageStringFile.DEVICE_LIMIT_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1306
  // Does my subscription give me access to workouts on all my devices (laptop, phone, tablet, etc)?
  val DEVICE_LIMIT_QUESTION get() = languageStringFile.DEVICE_LIMIT_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1501
  // You have not purchased a subscription.
  val DIDNT_PURCHASE_SUBSCRIPTION get() = languageStringFile.DIDNT_PURCHASE_SUBSCRIPTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3946
  // Dislike
  val DISLIKE get() = languageStringFile.DISLIKE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1502
  // I don’t see my subscription
  val DONT_SEE_SUBSCRIPTION get() = languageStringFile.DONT_SEE_SUBSCRIPTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=629
  // Download
  val DOWNLOAD get() = languageStringFile.DOWNLOAD
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2557
  // You can find this practice in the Offline Practices page once the download has completed.
  val DOWNLOAD_EXPLANATION get() = languageStringFile.DOWNLOAD_EXPLANATION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2559
  // Download Practice
  val DOWNLOAD_PRACTICE get() = languageStringFile.DOWNLOAD_PRACTICE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2556
  // Download Started
  val DOWNLOAD_STARTED get() = languageStringFile.DOWNLOAD_STARTED
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2555
  // Downloading... {1}%
  fun DOWNLOADING_VIDEO_PROGRESS(p0: Any) = languageStringFile.DOWNLOADING_VIDEO_PROGRESS(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3947
  // Edit
  val EDIT get() = languageStringFile.EDIT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=491
  // Edit Email
  val EDIT_EMAIL get() = languageStringFile.EDIT_EMAIL
  
  // https://worker.downdogapp.com/debug/appString?appStringId=628
  // Edit Name
  val EDIT_NAME get() = languageStringFile.EDIT_NAME
  
  // https://worker.downdogapp.com/debug/appString?appStringId=492
  // Edit Password
  val EDIT_PASSWORD get() = languageStringFile.EDIT_PASSWORD
  
  // https://worker.downdogapp.com/debug/appString?appStringId=462
  // Email
  val EMAIL get() = languageStringFile.EMAIL
  
  // https://worker.downdogapp.com/debug/appString?appStringId=137
  // Email and Password
  val EMAIL_AND_PASSWORD get() = languageStringFile.EMAIL_AND_PASSWORD
  
  // https://worker.downdogapp.com/debug/appString?appStringId=197
  // English pose names
  val ENGLISH_POSE_NAMES get() = languageStringFile.ENGLISH_POSE_NAMES
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3370
  // 1.  Open your Settings app.
  //                                     
  // 2.  Navigate to Notifications.
  //                                     
  // 3.  Find the {1} app, and make sure <b>notifications are enabled.</b>
  fun ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_INSTRUCTIONS(p0: Any) = languageStringFile.ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_INSTRUCTIONS(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3304
  // Make sure you have push notifications enabled for Down Dog on your mobile devices.
  val ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_PROMPT get() = languageStringFile.ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_PROMPT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=146
  // Enter Code
  val ENTER_CODE get() = languageStringFile.ENTER_CODE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=138
  // Enter email address
  val ENTER_EMAIL_ADDRESS get() = languageStringFile.ENTER_EMAIL_ADDRESS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=139
  // Enter password
  val ENTER_PASSWORD get() = languageStringFile.ENTER_PASSWORD
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2170
  // Equipment
  val EQUIPMENT get() = languageStringFile.EQUIPMENT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=88
  // Uh oh! There was an error connecting to the Health app
  val ERROR_CONNECTING_TO_APPLE_HEALTH_MESSAGE get() = languageStringFile.ERROR_CONNECTING_TO_APPLE_HEALTH_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=56
  // Uh oh!  There was an error connecting to Google Fit.
  val ERROR_CONNECTING_TO_GOOGLE_FIT_MESSAGE get() = languageStringFile.ERROR_CONNECTING_TO_GOOGLE_FIT_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=57
  // An error occurred.  Please contact us for support.
  val ERROR_OCCURRED_MESSAGE get() = languageStringFile.ERROR_OCCURRED_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1198
  // <b>Yoga</b>
  // 
  // Yes! From your full settings, under Practice, tap <b>View Poses</b>.  From here you can "dislike" poses and they will be excluded from any future practice.
  // 
  // On the <b>View Poses</b> page, you can also "like" select poses, which will increase the probability that they will appear in future practices. 
  // 
  // Please note that the Liked and Excluded poses feature is only available for the new practice types of Vinyasa, Restorative, Yin, Gentle, and Hatha.  Older practice types do not support this feature.
  // 
  // Please also note that liking/disliking poses will impact variety.
  // 
  // <b>HIIT</b>
  // 
  // Yes! Under Practice, tap <b>Mix</b>. From there, tap on the + to the left of each body part and you will see a list of exercises come up. Tap on the specific exercises you want to exclude them from your practice.
  // 
  // <b>Prenatal, Barre</b>
  // 
  // We don’t currently have this feature, but it’s definitely on our list! For now, on the mobile app, you can skip any pose you don't like by swiping left when it comes up. On the web app, click the forward arrow on the bottom left of the screen.
  val EXCLUDE_POSES_ANSWER get() = languageStringFile.EXCLUDE_POSES_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1187
  // Can I exclude particular poses from my practice?
  val EXCLUDE_POSES_QUESTION get() = languageStringFile.EXCLUDE_POSES_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1262
  // Exercise advice
  val EXERCISE_ADVICE get() = languageStringFile.EXERCISE_ADVICE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1602
  // Exercise List
  val EXERCISE_LIST get() = languageStringFile.EXERCISE_LIST
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3254
  // Exercise Names
  val EXERCISE_NAMES get() = languageStringFile.EXERCISE_NAMES
  
  // https://worker.downdogapp.com/debug/appString?appStringId=267
  // Exit
  val EXIT get() = languageStringFile.EXIT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=268
  // Exit Practice
  val EXIT_PRACTICE get() = languageStringFile.EXIT_PRACTICE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=156
  // Are you sure you want to leave your current practice?
  val EXIT_PRACTICE_MESSAGE get() = languageStringFile.EXIT_PRACTICE_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2720
  // Explicit Lyrics
  val EXPLICIT_LYRICS get() = languageStringFile.EXPLICIT_LYRICS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=280
  // Facebook
  val FACEBOOK get() = languageStringFile.FACEBOOK
  
  // https://worker.downdogapp.com/debug/appString?appStringId=58
  // Facebook Authentication Failure.  Please try again later.
  val FACEBOOK_AUTHENTICATION_FAILURE_MESSAGE get() = languageStringFile.FACEBOOK_AUTHENTICATION_FAILURE_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=147
  // Facebook Community
  val FACEBOOK_COMMUNITY get() = languageStringFile.FACEBOOK_COMMUNITY
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2552
  // Failed to download practice
  val FAILED_PRACTICE_DOWNLOAD get() = languageStringFile.FAILED_PRACTICE_DOWNLOAD
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2568
  // Something went wrong while downloading this practice. Please try again.
  val FAILED_PRACTICE_DOWNLOAD_EXPLANATION get() = languageStringFile.FAILED_PRACTICE_DOWNLOAD_EXPLANATION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1308
  // Unfortunately, we do not support Apple Family Sharing.
  val FAMILY_SHARING_ANSWER get() = languageStringFile.FAMILY_SHARING_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1307
  // Can I share my subscription with family members?
  val FAMILY_SHARING_QUESTION get() = languageStringFile.FAMILY_SHARING_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1434
  // FAQ Page
  val FAQ_PAGE get() = languageStringFile.FAQ_PAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=269
  // Add to Favorites
  val FAVORITE get() = languageStringFile.FAVORITE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=278
  // Favorites
  val FAVORITES get() = languageStringFile.FAVORITES
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1261
  // Feature request
  val FEATURE_REQUEST get() = languageStringFile.FEATURE_REQUEST
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2153
  // Feedback (optional)
  val FEEDBACK_OPTIONAL get() = languageStringFile.FEEDBACK_OPTIONAL
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1274
  // Thanks for writing in! 
  val FEEDBACK_SUBMITTED_TEXT get() = languageStringFile.FEEDBACK_SUBMITTED_TEXT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2553
  // Creating Practice...
  val FETCHING_PRACTICE get() = languageStringFile.FETCHING_PRACTICE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1417
  // No.
  val FITBIT_ANSWER get() = languageStringFile.FITBIT_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1416
  // Do the apps connect to FitBit?
  val FITBIT_QUESTION get() = languageStringFile.FITBIT_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=140
  // Forgot Password?
  val FORGOT_PASSWORD get() = languageStringFile.FORGOT_PASSWORD
  
  // https://worker.downdogapp.com/debug/appString?appStringId=461
  // Enter your email first in order to reset your password.
  val FORGOT_PASSWORD_NEEDS_EMAIL get() = languageStringFile.FORGOT_PASSWORD_NEEDS_EMAIL
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1291
  // Free for Healthcare Workers
  val FREE_FOR_HEALTHCARE_WORKERS get() = languageStringFile.FREE_FOR_HEALTHCARE_WORKERS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1110
  // Free for Schools
  val FREE_FOR_SCHOOLS get() = languageStringFile.FREE_FOR_SCHOOLS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1395
  // Get Free Corporate Membership
  val GET_COMPANIES_MEMBERSHIP get() = languageStringFile.GET_COMPANIES_MEMBERSHIP
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1393
  // Get Healthcare Membership
  val GET_HEALTHCARE_MEMBERSHIP get() = languageStringFile.GET_HEALTHCARE_MEMBERSHIP
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1392
  // Get Student Membership
  val GET_STUDENT_MEMBERSHIP get() = languageStringFile.GET_STUDENT_MEMBERSHIP
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1463
  // No. We currently do not offer this. 
  val GIFT_ANSWER get() = languageStringFile.GIFT_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3823
  // Buy your Down Dog gift (or gifts!)
  val GIFT_INSTRUCTIONS_CONTENT_1 get() = languageStringFile.GIFT_INSTRUCTIONS_CONTENT_1
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3824
  // Receive a Gift Certificate you can print or send to your friends and family
  val GIFT_INSTRUCTIONS_CONTENT_2 get() = languageStringFile.GIFT_INSTRUCTIONS_CONTENT_2
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3825
  // Recipients can use the QR code in their Certificate to start their year of access whenever they’re ready!
  val GIFT_INSTRUCTIONS_CONTENT_3 get() = languageStringFile.GIFT_INSTRUCTIONS_CONTENT_3
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3780
  // How it works:
  val GIFT_INSTRUCTIONS_TITLE get() = languageStringFile.GIFT_INSTRUCTIONS_TITLE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1462
  // Can I gift a subscription?
  val GIFT_QUESTION get() = languageStringFile.GIFT_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1440
  // Go to Apple Support
  val GO_TO_APPLE_SUPPORT get() = languageStringFile.GO_TO_APPLE_SUPPORT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1519
  // Goal Streak
  val GOAL_STREAK_CAPITALIZED get() = languageStringFile.GOAL_STREAK_CAPITALIZED
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1514
  // Goal streak
  val GOAL_STREAK_NOT_CAPITALIZED get() = languageStringFile.GOAL_STREAK_NOT_CAPITALIZED
  
  // https://worker.downdogapp.com/debug/appString?appStringId=281
  // Google
  val GOOGLE get() = languageStringFile.GOOGLE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=60
  // Google Authentication Failure.  Please try again later.
  val GOOGLE_AUTHENTICATION_FAILURE_MESSAGE get() = languageStringFile.GOOGLE_AUTHENTICATION_FAILURE_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1401
  // Unfortunately, we no longer support Google Fit.
  // 
  // Google made some changes that it made it very hard to continue integrating Google Fit into our offerings.
  val GOOGLE_FIT_ANSWER get() = languageStringFile.GOOGLE_FIT_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1400
  // Do the apps connect to Google Fit?
  val GOOGLE_FIT_QUESTION get() = languageStringFile.GOOGLE_FIT_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1495
  // <b>Yoga:</b>
  // 
  // <em>Try Yoga Nidra</em>
  // 
  // You can find <b>Yoga Nidra</b> in the Yoga app under practice <b>Type</b>. 
  // 
  // Note: Yoga Nidra is <b>audio only</b> - there will be no video. 
  // 
  // A lot of people enjoy setting the <b>Music</b> to Nature Sounds, Ambient, Brain Waves or Piano and Strings in the app. Try out a few and see which one you prefer!
  // 
  // If you're new to Yoga Nidra, we recommend listening to it with <b>Instruction Type</b> set to <b>Full Explanation</b> or <b>Default</b>.
  // 
  // You can also use Yoga Nidra to fall asleep.  After selecting Yoga Nidra as your practice Type, go to <b>Boost</b> and tap <b>Sleep</b>!
  // 
  // 
  // <b>Prenatal Yoga:</b>
  // 
  // Set your <b>Boost</b> to <b>Breathing</b>! This will give you some breathing exercises at the beginning of your practice, as well as a guided meditation at the end!
  // 
  // 
  // <b>Meditation:</b>
  // 
  // We have an entire app dedicated to meditation and breathing!  Check it out at <a href='https://meditation.downdogapp.com/download'>Meditation</a>!
  // 
  // If you're new to meditation, to receive the most instruction we offer, swipe up the settings view and set your <b>Guidance Amount</b> to <b>Most</b>, and set your <b>Longest Silence</b> to a short time like 30 seconds or 1 minute.
  val GUIDED_MEDITATION_AND_BREATHING_ANSWER get() = languageStringFile.GUIDED_MEDITATION_AND_BREATHING_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1494
  // How can I get more breathwork and guided meditation in my practice?
  val GUIDED_MEDITATION_AND_BREATHING_QUESTION get() = languageStringFile.GUIDED_MEDITATION_AND_BREATHING_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=95
  // Health Disclaimer and Warning
  val HEALTH_DISCLAIMER_AND_WARNING get() = languageStringFile.HEALTH_DISCLAIMER_AND_WARNING
  
  // https://worker.downdogapp.com/debug/appString?appStringId=97
  // * Yoga Buddhi Co. offers health and fitness information designed for education purposes only. You should not rely on the information in any Application made by Yoga Buddhi Co. (including but not limited to desktop, mobile, and device Applications, website, blogs, and any social media pages maintained by Yoga Buddhi Co. or Down Dog) as a substitute for professional medical advice, diagnosis, or treatment. We do not in any way guarantee or warrant the accuracy, completeness, or usefulness of any content found in any Application. The use of any information provided on this or any other Application made by Yoga Buddhi Co. is solely at your own risk. We assume no responsibility for injuries suffered while practicing these techniques and Yoga Buddhi Co. shall not be held liable for any damages, circumstances, conditions or injuries that may occur, directly or indirectly, from engaging in any activities or ideas presented in any Application made by Yoga Buddhi Co. Practicing yoga carries risk of injury. We do not recommend yoga exercises without appropriate supervision if you are pregnant or under 18 years of age. By using any Application, you accept all responsibility for your health and any resultant injury or mishap that may affect your well-being or health and/or your baby’s well-being or health in any way. Consult with your physician or health care provider before starting any fitness program, or if you have any questions or concerns about your health. Do not start a fitness program if your physician or healthcare provider advises against it. If you experience faintness, dizziness, pain or shortness of breath at any time while exercising, you should stop immediately and seek immediate medical attention. 
  val HEALTH_WAIVER_TEXT get() = languageStringFile.HEALTH_WAIVER_TEXT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1391
  // Healthcare providers are eligible for free membership until June 1, 2022!
  val HEALTHCARE_FREE_UNTIL_JANUARY_1_LONG get() = languageStringFile.HEALTHCARE_FREE_UNTIL_JANUARY_1_LONG
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1459
  // Healthcare Memberships
  val HEALTHCARE_MEMBERSHIPS get() = languageStringFile.HEALTHCARE_MEMBERSHIPS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1753
  // Here are your settings!
  val HERE_ARE_YOUR_SETTINGS get() = languageStringFile.HERE_ARE_YOUR_SETTINGS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=785
  // HIIT
  val HIIT get() = languageStringFile.HIIT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=758
  // Interval Training Workout
  val HIIT_GOOGLE_FIT_DESCRIPTION get() = languageStringFile.HIIT_GOOGLE_FIT_DESCRIPTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=282
  // History
  val HISTORY get() = languageStringFile.HISTORY
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1517
  // {1} Hr
  fun HOURS_SHORT(p0: Any) = languageStringFile.HOURS_SHORT(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1176
  // There are 9 total lessons in our intro!  
  //  
  // If you tap <b>Type</b>, you'll see the 3 categories of Vinyasa, Hatha, and Restorative. 
  //  
  // Then, once you've selected your <b>Type</b>, tap the number (<b>1, 2, or 3</b>) to do the corresponding lesson.  The numbered lessons are designed to build on one another, so we recommend starting on 1 first.  If the circle has a white background, that is the lesson of that Type that is selected. 
  val HOW_MANY_INTRO_LESSONS_ANSWER get() = languageStringFile.HOW_MANY_INTRO_LESSONS_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1168
  // How many Intro lessons are there?
  val HOW_MANY_INTRO_LESSONS_QUESTION get() = languageStringFile.HOW_MANY_INTRO_LESSONS_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1475
  // <b>How to Manage or Cancel Your Subscription</b> 
  // 
  // <em>If you purchased your subscription on the web</em>: 
  // 
  // 1. Go to <b>Settings</b>. On mobile, you can get there by tapping the three horizontal lines at the bottom right of the screen. On web, Settings is in the left sidebar. 
  // 2. Under <b>Settings</b>, tap <b>Subscription</b>. 
  // 3. Then you should see more info, including how to cancel or change your subscription, including turning off auto-renew. 
  // 
  // <em>If you purchased your subscription through the mobile app</em>:
  // 
  // You can manage your subscription through the <a href="https://support.apple.com/en-us/HT202039" target="_blank">Apple App Store</a> or through the <a href="https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en" target="_blank">Google Play Store</a>. 
  // 
  // <b>About Your Subscription</b> 
  // 
  // You will never be charged for a subscription unless you explicitly purchase a membership through our website, Apple, or Google. Subscriptions are found under the email address that you used when you purchased the subscription. If you do not see a subscription listed in your account, it means you do not have a subscription associated with the email address you currently logged in with. It is possible that your subscription may be associated with another email address, and if that is the case, you will need to log out and then log back in under that email address to see your subscription.
  val HOW_TO_CANCEL_ANSWER get() = languageStringFile.HOW_TO_CANCEL_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1476
  // I want to cancel my subscription.
  val HOW_TO_CANCEL_QUESTION get() = languageStringFile.HOW_TO_CANCEL_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=99
  // I Agree
  val I_AGREE get() = languageStringFile.I_AGREE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1352
  // I have a different question
  val I_HAVE_A_DIFFERENT_QUESTION get() = languageStringFile.I_HAVE_A_DIFFERENT_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1264
  // I have another question about:
  val I_HAVE_A_QUESTION_ABOUT get() = languageStringFile.I_HAVE_A_QUESTION_ABOUT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1383
  // I still need help
  val I_STILL_NEED_HELP get() = languageStringFile.I_STILL_NEED_HELP
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1387
  // I want a refund.
  val I_WANT_A_REFUND get() = languageStringFile.I_WANT_A_REFUND
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3292
  // <b>Yoga</b> 
  // 
  // With our Liked and Excluded poses feature, you can "like" select poses, which will increase the probability that they will appear in future practices.  From your full settings, under <b>Practice</b>, tap <b>View Poses</b>. From here you can "like" the poses you'd like to see more of in your practices. 
  // 
  // From <b>View Poses</b>, you can also "dislike" poses and they will be excluded from any future practice.
  // 
  // Please note that the Liked and Excluded poses feature is only available for the new practice types of Vinyasa, Restorative, Yin, Gentle, and Hatha.  Older practice types do not support this feature.
  // 
  // Please also note that liking/disliking poses will impact variety.
  // 
  // 
  // <b>HIIT</b> 
  // 
  // Yes! Under Practice, tap <b>Mix</b>. From there, tap on the + to the left of each body part and you will see a list of exercises come up. Tap on the specific exercises you want to exclude them from your practice.
  // 
  // 
  // <b>Prenatal, Barre</b>
  // 
  // We don’t currently have this feature, but it’s definitely on our list! For now, on the mobile app, you can skip any pose you don't like by swiping left when it comes up. On the web app, click the forward arrow on the bottom left of the screen.
  val INCLUDE_POSES_ANSWER get() = languageStringFile.INCLUDE_POSES_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3291
  // Can I include particular poses in my practice?
  val INCLUDE_POSES_QUESTION get() = languageStringFile.INCLUDE_POSES_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=155
  // Instagram
  val INSTAGRAM get() = languageStringFile.INSTAGRAM
  
  // https://worker.downdogapp.com/debug/appString?appStringId=61
  // That doesn't appear to be a valid email address. Please try again.
  val INVALID_EMAIL_MESSAGE get() = languageStringFile.INVALID_EMAIL_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=161
  // Keep timeline visible
  val KEEP_TIMELINE_VISIBLE get() = languageStringFile.KEEP_TIMELINE_VISIBLE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=250
  // Language
  val LANGUAGE get() = languageStringFile.LANGUAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1426
  // Your latest payment was:
  val LATEST_PAYMENT get() = languageStringFile.LATEST_PAYMENT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1396
  // Learn More
  val LEARN_MORE get() = languageStringFile.LEARN_MORE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=168
  // Length
  val LENGTH get() = languageStringFile.LENGTH
  
  // https://worker.downdogapp.com/debug/appString?appStringId=254
  // Less
  val LESS get() = languageStringFile.LESS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1179
  // Because everybody is different, you might try moving up one level and see how that feels.  Some days you may want to go down a level, other days you may feel like trying something new!  Most importantly, listen to the feedback your body gives you, and move slowly and with control.
  // 
  // The <a href="https://www.facebook.com/groups/183894272193568/" target="_blank">Facebook Community</a>, accessible via the <b>Settings</b> page on the app, is a great resource for getting advice from other people using the app!
  val LEVEL_ANSWER get() = languageStringFile.LEVEL_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1171
  // When should I move up a level?
  val LEVEL_QUESTION get() = languageStringFile.LEVEL_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=344
  // Lifetime
  val LIFETIME get() = languageStringFile.LIFETIME
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1465
  // No. We currently do not offer this.
  val LIFETIME_ANSWER get() = languageStringFile.LIFETIME_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1464
  // Can I purchase a lifetime subscription?
  val LIFETIME_QUESTION get() = languageStringFile.LIFETIME_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3945
  // Like
  val LIKE get() = languageStringFile.LIKE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3047
  // Like or Dislike poses to improve your future practices
  val LIKE_OR_DISLIKE_EXPLANATION get() = languageStringFile.LIKE_OR_DISLIKE_EXPLANATION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3199
  // {1} Liked, {2} Disliked
  fun LIKED_DISLIKED_COUNT(p0: Any, p1: Any) = languageStringFile.LIKED_DISLIKED_COUNT(p0, p1)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2030
  // Lock screen media controls
  val LOCK_SCREEN_MEDIA_CONTROLS get() = languageStringFile.LOCK_SCREEN_MEDIA_CONTROLS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1729
  // Log In
  val LOG_IN get() = languageStringFile.LOG_IN
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1407
  // You are logged in as {1}. 
  fun LOGGED_IN_AS(p0: Any) = languageStringFile.LOGGED_IN_AS(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=310
  // Login Error
  val LOGIN_ERROR get() = languageStringFile.LOGIN_ERROR
  
  // https://worker.downdogapp.com/debug/appString?appStringId=141
  // Logout
  val LOGOUT get() = languageStringFile.LOGOUT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=62
  // It doesn't look like you're connected to the internet. Please reconnect in order to switch accounts.
  val LOGOUT_NO_INTERNET_MESSAGE get() = languageStringFile.LOGOUT_NO_INTERNET_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1456
  // If you are a student or teacher, check out our {1}
  fun LOOK_SCHOOL_PAGE(p0: Any) = languageStringFile.LOOK_SCHOOL_PAGE(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1227
  // You can change between different visual types!  Start a practice, then pause it.  Tap on the <b>Gear icon</b> in the upper right corner. Tap <b>Video Quality</b>. You should see options for higher and lower quality video. This setting is only available on the yoga apps. 
  val LOWER_VIDEO_QUALITY_ANSWER get() = languageStringFile.LOWER_VIDEO_QUALITY_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1217
  // The videos are taking up too much of my phone’s storage.
  val LOWER_VIDEO_QUALITY_QUESTION get() = languageStringFile.LOWER_VIDEO_QUALITY_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2158
  // Make sure to vote for every option!
  val MAKE_SURE_TO_VOTE_FOR_EVERY_OPTION get() = languageStringFile.MAKE_SURE_TO_VOTE_FOR_EVERY_OPTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1486
  // We try not to send too many emails, but please note that emails are a primary way we let our community know of special sales and new features!
  // 
  // You can control whether you are subscribed or unsubscribed to our emails by going to <b>Settings</b> and then scrolling down to <b>Receive Promo Emails</b> and toggling on or off. 
  val MANAGE_EMAIL_PREFERENCES_ANSWER get() = languageStringFile.MANAGE_EMAIL_PREFERENCES_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1488
  // How do I manage my email preferences?
  val MANAGE_EMAIL_PREFERENCES_QUESTION get() = languageStringFile.MANAGE_EMAIL_PREFERENCES_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1161
  // <b>Yoga and Prenatal Yoga:</b>
  // 
  // You can turn up the amount of talking by swiping up the settings view and then tapping on <b>Instruction</b>.  Tap <b>Full </b> to receive the most amount of instruction we offer. 
  // 
  // <b>Meditation:</b>
  // 
  // To receive the most instruction we offer, set your <b>Guidance Amount</b> to <b>Most</b>, and set your <b>Longest Silence</b> to a short time like 30 seconds or 1 minute.
  // 
  // <b>HIIT and Barre:</b>
  // We currently do not offer the ability to change the amount of talking on HIIT and Barre. 
  val MAXIMUM_VERBOSITY_ANSWER get() = languageStringFile.MAXIMUM_VERBOSITY_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1160
  // I want to hear the most instruction possible when doing the poses.
  val MAXIMUM_VERBOSITY_QUESTION get() = languageStringFile.MAXIMUM_VERBOSITY_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1661
  // Meditation
  val MEDITATION get() = languageStringFile.MEDITATION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1672
  // Meditation Practice
  val MEDITATION_GOOGLE_FIT_DESCRIPTION get() = languageStringFile.MEDITATION_GOOGLE_FIT_DESCRIPTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1431
  // No. Subscriptions start as soon as you purchase. 
  // 
  // If you are in a free trial period, you may want to wait until the trial is over to purchase, however if we are running a special sale, this may mean missing out on the best price - we know this can make it a hard decision! 
  // 
  // Whether we're running a special sale or not, our website usually offers the best price at the time, so make sure to go to <a href="/purchase">downdogapp.com/purchase</a> when you're ready to purchase!
  // 
  val MEMBERSHIP_DELAYED_START_ANSWER get() = languageStringFile.MEMBERSHIP_DELAYED_START_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1430
  // Can I delay my subscription start date?
  val MEMBERSHIP_DELAYED_START_QUESTION get() = languageStringFile.MEMBERSHIP_DELAYED_START_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=148
  // Menu
  val MENU get() = languageStringFile.MENU
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1163
  // <b>Yoga and Prenatal Yoga:</b>
  // 
  // You can turn down the amount of talking by swiping up the settings view, and then tapping on <b>Instruction</b>. Tap <b>Least</b> to receive the least amount of instruction we offer.
  // 
  // <b>Meditation:</b>
  // 
  // To receive the least instruction we offer, swipe up the settings view and set your <b>Guidance Amount</b> to <b>Least</b>, and set your <b>Longest Silence</b> to a longer duration such as 5 minutes or more!
  // 
  // <b>HIIT and Barre:</b>
  // We currently do not offer the ability to change the amount of talking on HIIT and Barre. 
  val MINIMUM_VERBOSITY_ANSWER get() = languageStringFile.MINIMUM_VERBOSITY_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1162
  // I want to zone out and hear the least amount of instruction available.
  val MINIMUM_VERBOSITY_QUESTION get() = languageStringFile.MINIMUM_VERBOSITY_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=309
  // {1} Minutes
  fun MINUTES(p0: Any) = languageStringFile.MINUTES(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1254
  // {1} Min
  fun MINUTES_SHORT(p0: Any) = languageStringFile.MINUTES_SHORT(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1610
  // minutes
  val MINUTES_WITHOUT_NUMBER get() = languageStringFile.MINUTES_WITHOUT_NUMBER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1554
  // Mirror Video
  val MIRROR_VIDEO get() = languageStringFile.MIRROR_VIDEO
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3
  // Down Dog has been added as a source in the Health app. However, to start logging practices, you will need to enable the Workouts permission for Down Dog from within the Health app.
  val MISSING_APPLE_HEALTH_PERMISSIONS_MESSAGE get() = languageStringFile.MISSING_APPLE_HEALTH_PERMISSIONS_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1583
  // Mix
  val MIX get() = languageStringFile.MIX
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1510
  // Monday
  val MONDAY get() = languageStringFile.MONDAY
  
  // https://worker.downdogapp.com/debug/appString?appStringId=519
  // month
  val MONTH get() = languageStringFile.MONTH
  
  // https://worker.downdogapp.com/debug/appString?appStringId=377
  // monthly
  val MONTHLY get() = languageStringFile.MONTHLY
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1290
  // Monthly
  val MONTHLY_CAPITALIZED get() = languageStringFile.MONTHLY_CAPITALIZED
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1511
  // Monthly practices
  val MONTHLY_PRACTICES get() = languageStringFile.MONTHLY_PRACTICES
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1516
  // {1} Time
  fun MONTHLY_TIME(p0: Any) = languageStringFile.MONTHLY_TIME(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1513
  // Monthly time practiced
  val MONTHLY_TIME_PRACTICED get() = languageStringFile.MONTHLY_TIME_PRACTICED
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1482
  // If you have already purchased a monthly subscription, but would prefer a yearly subscription instead, you will need to take a few steps, depending on how you made your current purchase. 
  // 
  // <em>If you purchased via our <b>website</b> or <b>Google Play</b></em>: 
  // 
  // If you purchased your current subscription through the web, go to <b>Settings</b> and then <b>Subscriptions</b> to cancel your current subscription. If you purchased through Google Play, you can cancel your current subscription through the <a href="https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en" target="_blank">Google Play Store</a>. After cancelling your current subscription, you can <a href="/purchase">purchase a new subscription through our website</a>. 
  // 
  // Please note, if you choose to cancel and repurchase, we will not be able to offer you a partial refund. In some limited circumstances, you may be eligible for a refund of your current purchase - you can check your refund eligibility by clicking on "I want a refund" at <a href="/support">Support</a>. If you are eligible for a refund and have successfully requested and received confirmation of a refund at "I want a refund" at <a href="/support">Support</a>, then your current subscription is automatically cancelled. Then you can <a href="/purchase">purchase a new subscription through our website</a>. 
  // 
  // <em>If you purchased your subscription through <b>Apple</b></em>: 
  // 
  // You will need to cancel your subscription <a href="https://support.apple.com/en-us/HT202039" target="_blank">through the Apple App Store</a>. Please note, we are unable to issue refunds for purchases made through Apple. After you have canceled your current subscription through Apple, you can <a href="/purchase">purchase a new subscription through our website</a>, which usually has the best price!
  val MONTHLY_TO_YEARLY_ANSWER get() = languageStringFile.MONTHLY_TO_YEARLY_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1481
  // I bought a monthly subscription but I want to switch to an annual subscription.
  val MONTHLY_TO_YEARLY_QUESTION get() = languageStringFile.MONTHLY_TO_YEARLY_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=276
  // More
  val MORE get() = languageStringFile.MORE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=182
  // Music
  val MUSIC get() = languageStringFile.MUSIC
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1140
  // Once you've started a practice, if you tap the screen and pause your practice, you can adjust the music and voice volume by using the <b>Music/Voice mixing slider</b>.
  // 
  // After you have set the Music/Voice ratio that you prefer, then you can use your device to increase or decrease the overall volume.
  val MUSIC_VOLUME_VS_VOICE_ANSWER get() = languageStringFile.MUSIC_VOLUME_VS_VOICE_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1139
  // I can’t hear the instructor’s voice!  Where’s the volume control?
  val MUSIC_VOLUME_VS_VOICE_QUESTION get() = languageStringFile.MUSIC_VOLUME_VS_VOICE_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=400
  // My Data
  val MY_DATA get() = languageStringFile.MY_DATA
  
  // https://worker.downdogapp.com/debug/appString?appStringId=429
  // Uh oh! You need to be connected to the internet in order to play this song preview.
  val NEED_INTERNET_FOR_SONG_PREVIEW_MESSAGE get() = languageStringFile.NEED_INTERNET_FOR_SONG_PREVIEW_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3587
  // New Password
  val NEW_PASSWORD get() = languageStringFile.NEW_PASSWORD
  
  // https://worker.downdogapp.com/debug/appString?appStringId=9
  // Next
  val NEXT get() = languageStringFile.NEXT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=403
  // Next Payment
  val NEXT_PAYMENT get() = languageStringFile.NEXT_PAYMENT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=483
  // Next Payment: {1}
  fun NEXT_PAYMENT_SUBTEXT(p0: Any) = languageStringFile.NEXT_PAYMENT_SUBTEXT(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1499
  // Yoga Nidra is <b>audio only</b> - there will be no video!
  // 
  // Yoga Nidra is a deeply relaxing guided meditation. You can find it under practice <b>Type</b>, scroll all the way to the bottom. A lot of people enjoy setting the <b>Music</b> to Nature Sounds, Ambient, Brainwaves or Piano & Strings in the app ... try out a few and see which one you prefer! 
  // 
  // If you're new to Yoga Nidra, we recommend listening to it with <b>Instruction Type</b> set to <b>Full Explanation</b> or <b>Default</b>. 
  // 
  // You can also use Yoga Nidra to fall asleep.  After selecting Yoga Nidra as your practice Type, go to <b>Boost</b> and tap <b>Sleep</b>!
  val NIDRA_AUDIO_ONLY_ANSWER get() = languageStringFile.NIDRA_AUDIO_ONLY_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1498
  // There is no video with my Yoga Nidra practice.
  val NIDRA_AUDIO_ONLY_QUESTION get() = languageStringFile.NIDRA_AUDIO_ONLY_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1472
  // We do not charge any exchange or conversion fees, but your bank might, so make sure to check with them!
  val NO_EXCHANGE_FEES_ANSWER get() = languageStringFile.NO_EXCHANGE_FEES_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1471
  // Do you charge exchange fees?
  val NO_EXCHANGE_FEES_QUESTION get() = languageStringFile.NO_EXCHANGE_FEES_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=160
  // Please allow access to your email address in order to log in with Facebook.
  val NO_FACEBOOK_EMAIL_MESSAGE get() = languageStringFile.NO_FACEBOOK_EMAIL_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=162
  // It doesn't look like you've completed any practices yet. Swipe back to the home screen to start your first practice!
  val NO_HISTORY_TEXT get() = languageStringFile.NO_HISTORY_TEXT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=63
  // We're having trouble communicating with our servers. Please check your internet connection and try again.
  val NO_INTERNET_MESSAGE get() = languageStringFile.NO_INTERNET_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1497
  // Because of licensing restrictions, our music will not accompany saved favorites if you are offline.
  // 
  // If you'd like to play your own music, you can do so through other apps on your device.  However, while the audio cues are turned up to max volume by default on phones and tablets, sometimes this isn't enough to overpower the sound coming from Spotify/iTunes/etc.
  // 
  // In those cases, we recommend either using an external speaker to play music, or using the web version <a href="/web">downdogapp.com/web</a> on a laptop or desktop, with your music turned down in the background.
  // 
  // 
  val NO_MUSIC_OFFLINE_ANSWER get() = languageStringFile.NO_MUSIC_OFFLINE_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1496
  // I'm offline and my saved favorite practice has no music.
  val NO_MUSIC_OFFLINE_QUESTION get() = languageStringFile.NO_MUSIC_OFFLINE_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2551
  // You haven't downloaded any practices yet. You can download practices from your history, or create a new one here!
  val NO_OFFLINE_PRACTICES get() = languageStringFile.NO_OFFLINE_PRACTICES
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1478
  // Unfortunately, we are unable to accommodate requests for partial or prorated refunds.
  // 
  // If you have already purchased a subscription, but would like a different subscription, you will need to take a few steps, depending on how you made your current purchase. 
  // 
  // <em>If you purchased via our <b>website</b> or <b>Google Play</b></em>: 
  // 
  // If you purchased your current subscription through the web, go to <b>Settings</b> and then <b>Subscriptions</b> to cancel your current subscription. If you purchased through Google Play, you can cancel your current subscription through the <a href="https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en" target="_blank">Google Play Store</a>. After cancelling your current subscription, you can <a href="/purchase">purchase a new subscription through our website</a>. 
  // 
  // Please note, if you choose to cancel and repurchase, we will not be able to offer you a partial refund. In some limited circumstances, you may be eligible for a refund of your current purchase - you can check your refund eligibility by clicking on "I want a refund" at <a href="/support">Support</a>. If you are eligible for a refund and have successfully requested and received confirmation of a refund at "I want a refund" at <a href="/support">Support</a>, then your current subscription is automatically cancelled. Then you can <a href="/purchase">purchase a new subscription through our website</a>. 
  // 
  // <em>If you purchased your subscription through <b>Apple</b></em>: 
  // 
  // You will need to cancel your subscription <a href="https://support.apple.com/en-us/HT202039" target="_blank">through the Apple App Store</a>. Please note, we are unable to accommodate refund requests for purchases made through Apple. After you have canceled your current subscription through Apple, you can <a href="/purchase">purchase a new subscription through our website</a>, which usually has the best price!
  val NO_PARTIAL_REFUND_ANSWER get() = languageStringFile.NO_PARTIAL_REFUND_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1477
  // Can I get a partial refund?
  val NO_PARTIAL_REFUND_QUESTION get() = languageStringFile.NO_PARTIAL_REFUND_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=283
  // No Past Purchases
  val NO_PAST_PURCHASES get() = languageStringFile.NO_PAST_PURCHASES
  
  // https://worker.downdogapp.com/debug/appString?appStringId=163
  // It doesn't look like you've made any previous purchases. Please contact us if you think this is an error.
  val NO_PAST_PURCHASES_MESSAGE get() = languageStringFile.NO_PAST_PURCHASES_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1454
  // This payment is not refundable since you have completed a practice after purchasing. 
  val NO_REFUND_PRACTICED get() = languageStringFile.NO_REFUND_PRACTICED
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1455
  // This payment is not refundable because it took place over {1} days ago.  
  fun NO_REFUND_TIME(p0: Any) = languageStringFile.NO_REFUND_TIME(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=164
  // Save your favorite practices to replay later.
  val NO_SAVED_PRACTICES_TEXT get() = languageStringFile.NO_SAVED_PRACTICES_TEXT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1224
  // Here are some steps you can take to try and get sound out of the app:
  // 
  // • Have you made sure that your device itself isn't muted?  You can check this by playing music or audio through a different app.
  // • Have you checked that the in-app volume is on?  Once you've started a practice, you can adjust the balance between music and voice volume by pausing your practice, then adjusting the slider near the bottom of the screen. To hear both music and voice, make sure it's adjusted near the middle!
  // • Have you tried closing & reopening the app?
  // • Have you tried uninstalling and reinstalling the app?
  // • Have you tried using the web version of Down Dog (<a href="https://www.downdogapp.com/web" target="_blank">https://www.downdogapp.com/web</a>) to see if you have the same issue?
  val NO_SOUND_ANSWER get() = languageStringFile.NO_SOUND_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1214
  // I have no sound.
  val NO_SOUND_QUESTION get() = languageStringFile.NO_SOUND_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=10
  // No
  val NO_STRING get() = languageStringFile.NO_STRING
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1388
  // There are no active subscriptions on your account.
  val NO_SUBSCRIPTIONS_SUPPORT_MESSAGE get() = languageStringFile.NO_SUBSCRIPTIONS_SUPPORT_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=284
  // None
  val NONE get() = languageStringFile.NONE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1483
  // In September 2018, we moved to a new pricing model where we give people a brief free trial with full access to all features, and after that a subscription is required.  This pricing model is applied to all of our apps.
  // 
  // <b>Methods of Purchase</b>
  // 
  // <a href="/purchase">Purchasing through our website</a> will usually get you the best price! You can purchase on our website with a <b>credit card</b> or with <b>PayPal</b>. Purchasing through our website gives you access to everything in all apps, just as if you purchased in-app through Apple or Google. 
  // 
  // You can also purchase in-app through Apple or Google.  Please note, Apple and Google charge commission fees, which is why the in-app price will usually be higher than on our website. 
  // 
  // For purchases made outside of the United States, we do not charge any exchange fees, but your bank might, so make sure to check with them!
  val NOT_FREE_ANSWER get() = languageStringFile.NOT_FREE_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1468
  // I thought the app was free, why am I being asked to purchase a subscription?
  val NOT_FREE_QUESTION get() = languageStringFile.NOT_FREE_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=285
  // Ok
  val OK get() = languageStringFile.OK
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1686
  // Only {1}
  fun ONLY_MIX_GROUP(p0: Any) = languageStringFile.ONLY_MIX_GROUP(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=243
  // Open in Amazon
  val OPEN_IN_AMAZON get() = languageStringFile.OPEN_IN_AMAZON
  
  // https://worker.downdogapp.com/debug/appString?appStringId=216
  // Open in iTunes
  val OPEN_IN_ITUNES get() = languageStringFile.OPEN_IN_ITUNES
  
  // https://worker.downdogapp.com/debug/appString?appStringId=32
  // Open in Spotify
  val OPEN_IN_SPOTIFY get() = languageStringFile.OPEN_IN_SPOTIFY
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1257
  // Open in {1}
  fun OPEN_IN_X(p0: Any) = languageStringFile.OPEN_IN_X(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3948
  // Open Link
  val OPEN_LINK get() = languageStringFile.OPEN_LINK
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2149
  // Option {1} of {2}
  fun OPTION_X_OF_Y(p0: Any, p1: Any) = languageStringFile.OPTION_X_OF_Y(p0, p1)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=142
  // or
  val OR get() = languageStringFile.OR
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1111
  // Other
  val OTHER get() = languageStringFile.OTHER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1059
  // Other Apps
  val OTHER_APPS get() = languageStringFile.OTHER_APPS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=194
  // Pace
  val PACE get() = languageStringFile.PACE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=463
  // Password
  val PASSWORD get() = languageStringFile.PASSWORD
  
  // https://worker.downdogapp.com/debug/appString?appStringId=68
  // Your password should be at least four characters long.
  val PASSWORD_LENGTH_MESSAGE get() = languageStringFile.PASSWORD_LENGTH_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=445
  // Passwords must match
  val PASSWORDS_MUST_MATCH get() = languageStringFile.PASSWORDS_MUST_MATCH
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3944
  // Pause
  val PAUSE get() = languageStringFile.PAUSE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=339
  // Pay with
  val PAY_WITH get() = languageStringFile.PAY_WITH
  
  // https://worker.downdogapp.com/debug/appString?appStringId=349
  // Pay with PayPal
  val PAY_WITH_PAYPAL get() = languageStringFile.PAY_WITH_PAYPAL
  
  // https://worker.downdogapp.com/debug/appString?appStringId=480
  // PayPal
  val PAYPAL get() = languageStringFile.PAYPAL
  
  // https://worker.downdogapp.com/debug/appString?appStringId=347
  // There was an error authorizing your PayPal purchase.  Please try again in a few minutes, or contact customer support.
  val PAYPAL_AUTHORIZATION_ERROR_MESSAGE get() = languageStringFile.PAYPAL_AUTHORIZATION_ERROR_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1419
  // This payment has already been refunded.
  val PAYMENT_ALREADY_REFUNDED get() = languageStringFile.PAYMENT_ALREADY_REFUNDED
  
  // https://worker.downdogapp.com/debug/appString?appStringId=165
  // Payment Confirmed!
  val PAYMENT_CONFIRMED_MESSAGE get() = languageStringFile.PAYMENT_CONFIRMED_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1474
  // Here are the ways you can purchase a subscription!
  // 
  // 1) You can purchase through our website with a <b>credit card</b> or with <b>PayPal</b>. 
  // 
  // Purchasing through our website gives you access to everything in all apps, just as if you purchased in-app through Apple or Google. The price on our website is usually the best price because there are no Apple/Google commission fees involved.
  // 
  // 2) You can purchase in-app through Apple or Google. 
  // 
  // Please note, Apple and Google charge commission fees, which is why the in-app price will usually be higher than on our website.
  // 
  // For purchases made outside of the United States, we do not charge any exchange fees, but your bank might, so make sure to check with them!
  val PAYMENT_METHODS_ANSWER get() = languageStringFile.PAYMENT_METHODS_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1473
  // What payment methods do you accept?
  val PAYMENT_METHODS_QUESTION get() = languageStringFile.PAYMENT_METHODS_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=465
  // Plan
  val PAYMENT_PLAN get() = languageStringFile.PAYMENT_PLAN
  
  // https://worker.downdogapp.com/debug/appString?appStringId=317
  // per month
  val PER_MONTH get() = languageStringFile.PER_MONTH
  
  // https://worker.downdogapp.com/debug/appString?appStringId=318
  // per year
  val PER_YEAR get() = languageStringFile.PER_YEAR
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2539
  // Pilates
  val PILATES get() = languageStringFile.PILATES
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2549
  // Pilates Workout
  val PILATES_GOOGLE_FIT_DESCRIPTION get() = languageStringFile.PILATES_GOOGLE_FIT_DESCRIPTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3943
  // Play
  val PLAY get() = languageStringFile.PLAY
  
  // https://worker.downdogapp.com/debug/appString?appStringId=55
  // Error getting product prices from Play Store
  val PLAY_STORE_PRODUCT_PRICES_MESSAGE get() = languageStringFile.PLAY_STORE_PRODUCT_PRICES_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=319
  // Playlist
  val PLAYLIST get() = languageStringFile.PLAYLIST
  
  // https://worker.downdogapp.com/debug/appString?appStringId=72
  // We had trouble changing your playlist type. Try again in a few seconds.
  val PLAYLIST_TYPE_BUSY get() = languageStringFile.PLAYLIST_TYPE_BUSY
  
  // https://worker.downdogapp.com/debug/appString?appStringId=73
  // It doesn't look like you're connected to the internet. Please reconnect in order to change music types.
  val PLAYLIST_TYPE_NO_INTERNET_MESSAGE get() = languageStringFile.PLAYLIST_TYPE_NO_INTERNET_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3049
  // We will exclude {1} from your future practices
  fun POSE_DISLIKED_MESSAGE(p0: Any) = languageStringFile.POSE_DISLIKED_MESSAGE(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1199
  // We do not currently offer a pose library, but it's in development!  Stay tuned!
  // 
  val POSE_LIBRARY_ANSWER get() = languageStringFile.POSE_LIBRARY_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1188
  // Do you offer a pose library so I can learn more about each pose?
  val POSE_LIBRARY_QUESTION get() = languageStringFile.POSE_LIBRARY_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3048
  // We will add more {1} to your future practices
  fun POSE_LIKED_MESSAGE(p0: Any) = languageStringFile.POSE_LIKED_MESSAGE(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1532
  // Pose List
  val POSE_LIST get() = languageStringFile.POSE_LIST
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3008
  // Explore all poses below, and designate which ones you’d like to see more or less of in future practices.
  val POSE_LIST_DESCRIPTION get() = languageStringFile.POSE_LIST_DESCRIPTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3252
  // Pose Names
  val POSE_NAMES get() = languageStringFile.POSE_NAMES
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3071
  // Poses
  val POSES get() = languageStringFile.POSES
  
  // https://worker.downdogapp.com/debug/appString?appStringId=286
  // Practice
  val PRACTICE get() = languageStringFile.PRACTICE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1275
  // Practice Feedback
  val PRACTICE_FEEDBACK get() = languageStringFile.PRACTICE_FEEDBACK
  
  // https://worker.downdogapp.com/debug/appString?appStringId=166
  // Practice added to Favorites!
  val PRACTICE_SAVED_CONFIRMATION get() = languageStringFile.PRACTICE_SAVED_CONFIRMATION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1515
  // Practice streak
  val PRACTICE_STREAK_NOT_CAPITALIZED get() = languageStringFile.PRACTICE_STREAK_NOT_CAPITALIZED
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1293
  // {1} Practices
  fun PRACTICES_IN_MONTH(p0: Any) = languageStringFile.PRACTICES_IN_MONTH(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=456
  // Prenatal Yoga
  val PRENATAL get() = languageStringFile.PRENATAL
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1200
  // Yes! We have a stand alone Prenatal Yoga app  included in all subscriptions that you should check out! You can find Prenatal Yoga on <a href="https://play.google.com/store/apps/details?id=com.downdogapp.prenatal" target="_blank">Android</a> and <a href="https://apps.apple.com/us/app/prenatal-yoga-down-dog/id1504152442" target="_blank">iOS</a>, or at <a href="https://prenatal.downdogapp.com/web" target="_blank">prenatal.downdogapp.com/web</a>. This app will let you tailor your practice by trimester. It also has many of the same boosts that our main yoga app offers, plus some special ones specific to pregnancy.
  val PRENATAL_ANSWER get() = languageStringFile.PRENATAL_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1189
  // I’m pregnant!  Is there a prenatal option I can select?
  val PRENATAL_QUESTION get() = languageStringFile.PRENATAL_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1267
  // Prenatal
  val PRENATAL_SHORT get() = languageStringFile.PRENATAL_SHORT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2554
  // Preparing video... {1}% Complete
  fun PREPARING_VIDEO_PROGRESS(p0: Any) = languageStringFile.PREPARING_VIDEO_PROGRESS(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2569
  // We are preparing your video. Please keep the app open until the download begins or return to the app in a few minutes to initiate the download.
  val PREPARING_VIDEO_WARNING get() = languageStringFile.PREPARING_VIDEO_WARNING
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1405
  // <a href="/purchase">Purchasing through our website</a> avoids commission fees commonly charged by Apple or Google, and will usually get you the best price! You can purchase on our website with a <b>credit card</b> or with <b>PayPal</b>. Purchasing through our website gives you access to everything in all apps, just as if you purchased in-app through Apple or Google. You can use a web subscription on your computer, phone, and tablet.
  // 
  // You can also purchase a subscription in-app through Apple or Google.  Please note, Apple and Google charge commission fees, which is why the in-app price will usually be higher than on our website. 
  // 
  // For purchases made outside of the United States, we do not charge any exchange fees, but your bank might, so make sure to check with them!
  val PRICE_DIFFERENCE_ANSWER get() = languageStringFile.PRICE_DIFFERENCE_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1404
  // Why are the in-app prices different from web prices?  Are the memberships different?
  val PRICE_DIFFERENCE_QUESTION get() = languageStringFile.PRICE_DIFFERENCE_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=287
  // Privacy Policy
  val PRIVACY_POLICY get() = languageStringFile.PRIVACY_POLICY
  
  // https://worker.downdogapp.com/debug/appString?appStringId=398
  // Receive Promo Emails
  val PROMOTIONAL_EMAILS get() = languageStringFile.PROMOTIONAL_EMAILS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=351
  // A receipt will be sent to {1}.
  fun RECEIPT_SENT_TO_EMAIL_MESSAGE(p0: Any) = languageStringFile.RECEIPT_SENT_TO_EMAIL_MESSAGE(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1461
  // Upon purchase of a subscription, we send a receipt to the email address associated with your subscription. 
  // 
  // Unfortunately, receipts cannot be resent. If you need to locate the original receipt, we recommend searching in your email for the subject line "<b>YOUR DOWN DOG RECEIPT</b>." Make sure to check your spam folder!  
  val RECEIPTS_ANSWER get() = languageStringFile.RECEIPTS_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1460
  // Can you send me a receipt for my subscription purchase?
  val RECEIPTS_QUESTION get() = languageStringFile.RECEIPTS_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3799
  // Redeem
  val REDEEM get() = languageStringFile.REDEEM
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3798
  // Click the button below to claim 1 year of free access to Down Dog!  The gift (code {1}) will be credited to your account {2} starting the day you redeem the gift.
  fun REDEEM_GIFT_INSTRUCTIONS(p0: Any, p1: Any) = languageStringFile.REDEEM_GIFT_INSTRUCTIONS(p0, p1)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3797
  // Redeem Your Down Dog Gift Card
  val REDEEM_GIFT_VIEW_TITLE get() = languageStringFile.REDEEM_GIFT_VIEW_TITLE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1222
  // If you purchased your subscription on the web, you can request a refund through our <a href="/support">support</a> page. 
  val REFUND_ANSWER get() = languageStringFile.REFUND_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1212
  // How can I get a refund?
  val REFUND_QUESTION get() = languageStringFile.REFUND_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1424
  // Your refund is on its way.
  val REFUNDED_ON_WAY get() = languageStringFile.REFUNDED_ON_WAY
  
  // https://worker.downdogapp.com/debug/appString?appStringId=626
  // Remove from Favorites
  val REMOVE_FROM_FAVORITES get() = languageStringFile.REMOVE_FROM_FAVORITES
  
  // https://worker.downdogapp.com/debug/appString?appStringId=625
  // Remove from History
  val REMOVE_FROM_HISTORY get() = languageStringFile.REMOVE_FROM_HISTORY
  
  // https://worker.downdogapp.com/debug/appString?appStringId=663
  // Are you sure you want to remove this practice from your history?
  val REMOVE_FROM_HISTORY_MESSAGE get() = languageStringFile.REMOVE_FROM_HISTORY_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1206
  // Yes! Naming an individual practice is a great way to stay organized and it will help you remember why you loved it!
  // 
  // You can label ANY practices found in your History (regardless of whether it's a favorite or not). Simply tap on a practice in your History, and select <b>Edit Name</b>. 
  val RENAME_FAVORITES_ANSWER get() = languageStringFile.RENAME_FAVORITES_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1194
  // Can I name my favorite practices so I don’t forget which one is which?
  val RENAME_FAVORITES_QUESTION get() = languageStringFile.RENAME_FAVORITES_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3421
  // Please sign in using an email address with a {1} domain!
  fun REQUIRED_EMAIL_DOMAIN_ALERT(p0: Any) = languageStringFile.REQUIRED_EMAIL_DOMAIN_ALERT(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1910
  // Reset
  val RESET get() = languageStringFile.RESET
  
  // https://worker.downdogapp.com/debug/appString?appStringId=154
  // A link to reset your password has been sent to: {1}
  fun RESET_PASSWORD_MESSAGE(p0: Any) = languageStringFile.RESET_PASSWORD_MESSAGE(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=167
  // Resume Practice
  val RESUME_PRACTICE get() = languageStringFile.RESUME_PRACTICE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=169
  // Would you like to resume your previous practice?
  val RESUME_PRACTICE_MESSAGE get() = languageStringFile.RESUME_PRACTICE_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2245
  // Running
  val RUNNING get() = languageStringFile.RUNNING
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2255
  // Down Dog Running Workout
  val RUNNING_GOOGLE_FIT_DESCRIPTION get() = languageStringFile.RUNNING_GOOGLE_FIT_DESCRIPTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=66
  // For the best experience on phone or tablet, download the app from the App Store or Play Store.  On a desktop/laptop computer, use Chrome for most reliable playback.
  val SAFARI_OR_MOBILE_BROWSER_WARNING_MESSAGE get() = languageStringFile.SAFARI_OR_MOBILE_BROWSER_WARNING_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1480
  // Whenever we have a sale, you must purchase through our website to get the discounted price.
  // 
  // Purchases can be made on our website using a credit card or PayPal. For international transactions, we do not charge exchange fees, but your bank might, so make sure to check with them!
  // 
  // If you have already purchased a subscription, and you'd like to take advantage of a special sale we're having, you will have to take a few steps, depending on how you made your current purchase. Please note that a subscription purchase goes into effect immediately upon purchase and will cancel any current subscription. It will not be added onto the end of your current subscription.
  // 
  // <em>If you purchased via our <b>website</b> or <b>Google Play</b></em>: 
  // 
  // If you purchased your current subscription through the web, go to <b>Settings</b> and then <b>Subscriptions</b> to cancel your current subscription. If you purchased through Google Play, you can cancel your current subscription through the <a href="https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en" target="_blank">Google Play Store</a>. After cancelling your current subscription, you can purchase a new subscription through our website. 
  // 
  // Please note, if you choose to cancel and repurchase, we will not be able to offer you a partial refund. In some limited circumstances, you may be eligible for a refund of your current purchase - you can check your refund eligibility by clicking on "I want a refund" at <a href="/support">Support</a>. If you are eligible for a refund and have successfully requested and received confirmation of a refund at "I want a refund" at <a href="/support">Support</a>, then your current subscription is automatically cancelled. Then you can purchase a new subscription through our website. 
  // 
  // <em>If you purchased your subscription through <b>Apple</b></em>: 
  // 
  // You will need to cancel your subscription <a href="https://support.apple.com/en-us/HT202039" target="_blank">through the Apple App Store</a>. Please note, we are unable to accommodate refund requests for purchases made through Apple. After you have canceled your current subscription through Apple, you can purchase a new subscription through our website, which usually has the best price! 
  // 
  val SALE_PRICE_ANSWER get() = languageStringFile.SALE_PRICE_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1479
  // I got an email about a sale! How do I get the sale price?
  val SALE_PRICE_QUESTION get() = languageStringFile.SALE_PRICE_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=198
  // Sanskrit pose names
  val SANSKRIT_POSE_NAMES get() = languageStringFile.SANSKRIT_POSE_NAMES
  
  // https://worker.downdogapp.com/debug/appString?appStringId=454
  // Save
  val SAVE get() = languageStringFile.SAVE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=529
  // Save and Unlink
  val SAVE_AND_UNLINK get() = languageStringFile.SAVE_AND_UNLINK
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1204
  // Yes! There are a few ways to save a practice for offline use.  Note this only works on the mobile apps, not web.
  //  
  // <em>Download a practice you've never done before</em>
  // 
  // From your home screen, set all of the settings you'd like to have in a practice, then tap on the <b>Down Arrow</b> near the bottom of your screen. This will take you to your <b>Offline Practice</b> screen. If you tap on <b>Create Offline Practice</b> it will create and start downloading a new practice for you with your current settings.
  // 
  // <em>Download a practice you've already done</em>
  // 
  // From your home screen, tap on the <b>clock icon</b> near the bottom to see your practice <b>History</b>.  Tap on any practice in this list, and then scroll down and tap <b>Download Practice</b>.  
  // 
  // Note that this will only work for practices in your History that are from the app you are currently using. For example, if you have previously used the Meditation app to do a breathing practice, and you are currently using the Yoga app to view your History, the breathing practice you previously did will appear in your History list. Because this prior practice is from a different app than you are currently viewing, a little blue icon will appear next to this practice reflecting that it is from the Meditation app. You must go to the Meditation app and access your History list from there to have the option of downloading the breathing practice.
  // 
  // <em>View a downloaded practice</em>
  // 
  // From your home screen, tap on the <b>Down Arrow</b> near the bottom of your screen. This will take you to your <b>Offline Practice</b> screen. Any practice you see displayed has been downloaded and is ready to be played without an internet connection!
  // 
  // Please note, because of licensing restrictions, our music will not accompany saved favorites when you are offline.
  val SAVE_FOR_OFFLINE_ANSWER get() = languageStringFile.SAVE_FOR_OFFLINE_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1192
  // Can I use Down Dog offline?
  val SAVE_FOR_OFFLINE_QUESTION get() = languageStringFile.SAVE_FOR_OFFLINE_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1205
  // Yes!
  // 
  // <em>Save a Practice You Just Completed</em>
  // 
  // If you’d like to save a practice right after you've finished it, tap <b>Add to Favorites</b> on the post-practice page and it will save it to your <b>Favorites</b> and add a Heart icon to your practice. To access your <b>Favorites</b> , from the <b>History</b>  page  (accessible through the clock icon at the bottom of the main screen), you can click on any practice in your History with a heart icon, or toggle from <b>All</b>  to see only your <b>Favorites</b>.
  // 
  // <em>Save a Previous Practice from your History</em>
  // 
  // If you’d like to save a practice you did previously, go to your <b>History</b> page (tap the clock icon at the bottom of the home screen). Once you're there, scroll down and then tap on the practice that you want to save. You'll see the words <b>Add to Favorites</b> at the bottom. Pressing that will save the practice to your <b>Favorites</b> and add a Heart icon to your practice. To access your <b>Favorites</b> , from the <b>History</b>  page, you can click on any practice in your History with a Heart icon, or toggle from <b>All</b>  to see only your <b>Favorites</b>.
  // 
  // <em>Fun Fact!</em>
  // 
  // You can label ANY practices found in your History (regardless of whether it's a favorite or not). Simply tap on a practice in your History, and select <b>Edit Name</b>.
  val SAVE_TO_FAVORITES_ANSWER get() = languageStringFile.SAVE_TO_FAVORITES_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1193
  // Is there a way to save my favorite practices?
  val SAVE_TO_FAVORITES_QUESTION get() = languageStringFile.SAVE_TO_FAVORITES_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1458
  // School Memberships
  val SCHOOL_MEMBERSHIPS get() = languageStringFile.SCHOOL_MEMBERSHIPS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2150
  // Score
  val SCORE get() = languageStringFile.SCORE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2151
  // 1 (Hate it)
  val SCORE_HATE_IT get() = languageStringFile.SCORE_HATE_IT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2152
  // 5 (Love it)
  val SCORE_LOVE_IT get() = languageStringFile.SCORE_LOVE_IT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3951
  // Search
  val SEARCH get() = languageStringFile.SEARCH
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3108
  // Search for a pose
  val SEARCH_FOR_A_POSE get() = languageStringFile.SEARCH_FOR_A_POSE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3286
  // Search for an exercise
  val SEARCH_FOR_AN_EXERCISE get() = languageStringFile.SEARCH_FOR_AN_EXERCISE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1601
  // See exercises on timeline
  val SEE_EXERCISES_ON_TIMELINE get() = languageStringFile.SEE_EXERCISES_ON_TIMELINE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1587
  // See poses on timeline
  val SEE_POSES_ON_TIMELINE get() = languageStringFile.SEE_POSES_ON_TIMELINE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=270
  // Select
  val SELECT get() = languageStringFile.SELECT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=585
  // Send
  val SEND get() = languageStringFile.SEND
  
  // https://worker.downdogapp.com/debug/appString?appStringId=149
  // Send Feedback
  val SEND_FEEDBACK get() = languageStringFile.SEND_FEEDBACK
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1406
  // Sending feedback failed
  val SENDING_FEEDBACK_FAILED get() = languageStringFile.SENDING_FEEDBACK_FAILED
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2747
  // Sorry, that practice length is not possible with your current settings. Please select another length.
  val SEQUENCE_LENGTH_INVALID get() = languageStringFile.SEQUENCE_LENGTH_INVALID
  
  // https://worker.downdogapp.com/debug/appString?appStringId=297
  // Set Password
  val SET_PASSWORD get() = languageStringFile.SET_PASSWORD
  
  // https://worker.downdogapp.com/debug/appString?appStringId=430
  // Settings
  val SETTINGS get() = languageStringFile.SETTINGS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1177
  // <b>Yoga:</b>
  // 
  // <em>Set Your Level</em>
  // 
  // If you're new to yoga we recommend starting with Level <b>Beginner 1</b>, found under Practice settings.
  //  
  // <em>Choose Your Practice Type</em>
  // 
  // For a softer practice that includes standing poses as well as floor poses, try Practice Type <b>Gentle</b>. 
  // 
  // For a restful practice with only floor poses, try <b>Restorative</b>, or <b>Yin</b>, which will allow for the longest holds in the poses. 
  // 
  // For a faster, flowing, more energetic practice, try <b>Vinyasa</b>.
  // 
  // If you want to flow less, skip the chaturangas, and let the heat build by holding poses longer, try <b>Hatha</b>. 
  // 
  // <em>Instruction Level</em>
  // 
  // Set your <b>Instruction</b> level to <b>Full</b> to receive the most detailed instructions. 
  // 
  // <em>Set Your Transition Speed and Hold Length</em>
  // 
  // If you want to slow your practice down further, we recommend adjusting your <b>Transition Speed</b> to <b>Slowest</b> and your <b>Hold Lengths</b> to <b>Longest</b>. Please note older practice types do not support these features.
  // 
  // <em>Extend Your Warmup and Cooldown</em>
  // 
  // For Practice Types of Vinyasa, Hatha, and Gentle, adjust your <b>Warmup</b> and <b>Cooldown</b> to <b>Extended</b>. Please note older practice types do not support these features.
  // 
  // <em>Like and Exclude Poses</em>
  // For Practice Types of Vinyasa, Hatha, and Gentle, "like" poses and see them more often in your practice, or "dislike" poses and you'll never see them again.
  // 
  // 
  // <b>Prenatal Yoga:</b>
  // 
  // If you're new to yoga we recommend starting with Level <b>Beginner 1</b>, which is found by swiping up in settings view and looking under the Practice settings.
  // 
  // For a restful practice, we recommend starting out with <b>Restorative</b>, which is all floor work and will allow for the longest holds in the poses. 
  // 
  // 
  // <b>Meditation:</b>
  // 
  // If you're new to meditation, we recommend keeping your <b>Longest Silence</b> fairly short - the default is 2 minutes, but you can shorten it all the way down to 30 seconds if you'd prefer to have less silence and more guidance.  You can also set your <b>Guidance Amount</b> to <b>Most</b> to get the most instruction we offer!
  // 
  // 
  // <b>HIIT</b>
  // 
  // Our default settings are a great place to start! 
  // 
  // If HIIT is too challenging on Level 1, try Level 0!  You can also try spending a shorter time on each exercise. You can adjust this by  swiping up in settings view and adjusting your settings under Practice, where you can adjust your Exercise Length. You'll be surprised how big a difference 5 or 10 seconds can make! You can also decrease the length of your overall workout, and increase the length of each Recovery between exercises. 
  // 
  // We offer two practice types, <b>Rotation</b> and <b>Progression</b>. Select <b>Progression</b> to move through different parts of the body always in the same order, or choose <b>Rotation</b>to move through different parts of the body but mix up the order across different practices!
  // 
  // 
  // <b>Barre:</b>
  // 
  // You can adjust the difficulty by changing the length of your workout. Experienced athletes should start with 15 or 20 minutes, and work their way up if they want an additional challenge. If you're a beginner, you might want to start with just 5 minutes every day or 10 minutes every other day. Keep it up, and you'll be ready for longer workouts in no time! 
  // 
  val SETTINGS_FOR_BEGINNERS_ANSWER get() = languageStringFile.SETTINGS_FOR_BEGINNERS_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1169
  // I don't know where to start! What settings should I select to get the best experience?
  val SETTINGS_FOR_BEGINNERS_QUESTION get() = languageStringFile.SETTINGS_FOR_BEGINNERS_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1061
  // 7 Minute
  val SEVEN_MINUTE get() = languageStringFile.SEVEN_MINUTE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=150
  // Share
  val SHARE get() = languageStringFile.SHARE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1246
  // After completing your practice, or from your <b>History</b> or <b>Favorites</b>, tap <b>Share this Practice</b> to get a link to share that practice with your friends. 
  // 
  // When your friends click the link, they will be taken to the app, and they will get a pop-up message about the saved practice. They should tap <b>Yes</b> to make sure it gets saved to their <b>Favorites</b>!
  val SHARE_PRACTICE_ANSWER get() = languageStringFile.SHARE_PRACTICE_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1245
  // How can I share a practice with my friends?
  val SHARE_PRACTICE_QUESTION get() = languageStringFile.SHARE_PRACTICE_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1181
  // Share this Practice
  val SHARE_THIS_PRACTICE get() = languageStringFile.SHARE_THIS_PRACTICE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1235
  // Shared Practice
  val SHARED_PRACTICE get() = languageStringFile.SHARED_PRACTICE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3257
  // Show Exercise Names
  val SHOW_EXERCISE_NAMES get() = languageStringFile.SHOW_EXERCISE_NAMES
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3343
  // Show Like and Exclude Buttons
  val SHOW_LIKE_AND_EXCLUDE_BUTTONS get() = languageStringFile.SHOW_LIKE_AND_EXCLUDE_BUTTONS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2085
  // Show 'Next Up' Text
  val SHOW_OVERLAY get() = languageStringFile.SHOW_OVERLAY
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2082
  // Show Pose Names
  val SHOW_POSE_NAME get() = languageStringFile.SHOW_POSE_NAME
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1555
  // Show Subtitles
  val SHOW_SUBTITLES get() = languageStringFile.SHOW_SUBTITLES
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1728
  // Sign Up
  val SIGN_UP get() = languageStringFile.SIGN_UP
  
  // https://worker.downdogapp.com/debug/appString?appStringId=64
  // Sign Up / Login
  val SIGN_UP_LOGIN get() = languageStringFile.SIGN_UP_LOGIN
  
  // https://worker.downdogapp.com/debug/appString?appStringId=271
  // Skip
  val SKIP get() = languageStringFile.SKIP
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1173
  // <b>Yoga:</b>
  // 
  // There are a few settings you can adjust to slow down your practice - we recommend experimenting with them all!
  // 
  // <em>Transition Speed</em>
  // 
  // Swipe up to see your full settings. Under  <b>Timing</b>, tap on  <b>Transition Speed</b> and set it to <b>Slowest</b> to allow for the most time transitioning between one pose and another, then tap  <b>Select</b>.  Please note older practice types do not support this feature.
  // 
  // <em>Hold Lengths</em>
  // 
  // Swipe up to see your full settings. Under  <b>Timing</b>, tap on <b>Hold Lengths</b> and set it to <b>Longest</b> to allow for the most time in each pose, then tap  <b>Select</b> . Please note older practice types do not support this feature.
  // 
  // <em>Warmup</em> and <em>Cooldown</em>
  // 
  // Set your <b>Warmup</b> and <b>Cooldown</b> to <b>Extended</b>. Please note older practice types do not support these features.
  // 
  // <em>Instruction Level</em>
  // 
  // To get the most instruction and pointers, you can also set your <b>Instruction</b> level to <b>Full</b>.  
  // 
  // <em>Practice Types</em>
  // 
  // You might also try setting your practice <b>Type</b> to <b>Gentle</b> or <b>Hatha</b> rather than <b>Vinyasa</b> , to leave out the vinyasa flows/chaturangas.  Or if you’re looking to slow things down even more, set your practice <b>Type</b> to <b>Yin</b>, or <b>Restorative</b>!
  // 
  // 
  // <b>Prenatal Yoga:</b>
  // 
  // Swipe up in settings view and set your <b>Pace</b> to <b>Slowest</b> to spend the most time in each pose. To get the most instruction and pointers, you can also set your <b>Instruction</b> level to <b>Full Explanation</b>.
  // 
  // <b>HIIT:</b>
  // 
  // You can change the time spent on each exercise. Swipe up in settings view and under <b>Practice</b>, tap on <b>Exercise Length</b>. You can also adjust the rest time in between exercises by tapping on <b>Recovery</b>. 
  val SLOWER_PACE_ANSWER get() = languageStringFile.SLOWER_PACE_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1165
  // How can I slow down the speed of my practice?
  val SLOWER_PACE_QUESTION get() = languageStringFile.SLOWER_PACE_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=466
  // Social
  val SOCIAL get() = languageStringFile.SOCIAL
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2086
  // Something went wrong
  val SOMETHING_WENT_WRONG get() = languageStringFile.SOMETHING_WENT_WRONG
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1533
  // Song List
  val SONG_LIST get() = languageStringFile.SONG_LIST
  
  // https://worker.downdogapp.com/debug/appString?appStringId=288
  // Songs Played
  val SONGS_PLAYED get() = languageStringFile.SONGS_PLAYED
  
  // https://worker.downdogapp.com/debug/appString?appStringId=272
  // Start
  val START get() = languageStringFile.START
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1600
  // Start Practice
  val START_PRACTICE get() = languageStringFile.START_PRACTICE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=89
  // It doesn't look like you're connected to the internet. Please reconnect in order to start a new practice.
  val START_PRACTICE_NO_INTERNET_MESSAGE get() = languageStringFile.START_PRACTICE_NO_INTERNET_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2090
  // Would you like to start this shared practice?
  val START_SHARED_PRACTICE get() = languageStringFile.START_SHARED_PRACTICE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1507
  // What would you like to see?
  val STAT_TYPE_SUBTITLE get() = languageStringFile.STAT_TYPE_SUBTITLE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1506
  // Choose your stat
  val STAT_TYPE_TITLE get() = languageStringFile.STAT_TYPE_TITLE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1390
  // Students and teachers are eligible for free membership!
  val STUDENTS_FREE_UNTIL_JANUARY_1_LONG get() = languageStringFile.STUDENTS_FREE_UNTIL_JANUARY_1_LONG
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1268
  // Subject:
  val SUBJECT_COLON get() = languageStringFile.SUBJECT_COLON
  
  // https://worker.downdogapp.com/debug/appString?appStringId=273
  // Submit
  val SUBMIT get() = languageStringFile.SUBMIT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1266
  // Submitting...
  val SUBMITTING get() = languageStringFile.SUBMITTING
  
  // https://worker.downdogapp.com/debug/appString?appStringId=477
  // Subscription
  val SUBSCRIPTION get() = languageStringFile.SUBSCRIPTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1223
  // If you leave on autorenew, then yes! If you turn off autorenew, you will have the chance to resubscribe at whatever rate is available when you’re ready to resubscribe. Please note that for transactions made through Paypal, you cannot turn autorenew back on after you have turned it off.
  val SUBSCRIPTION_RENEWAL_PRICE_ANSWER get() = languageStringFile.SUBSCRIPTION_RENEWAL_PRICE_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1213
  // Does my subscription renew at the same price I purchased it?
  val SUBSCRIPTION_RENEWAL_PRICE_QUESTION get() = languageStringFile.SUBSCRIPTION_RENEWAL_PRICE_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1389
  // You are logged in as {1}. Here are the subscriptions on your account:
  fun SUBSCRIPTIONS_SUPPORT_MESSAGE(p0: Any) = languageStringFile.SUBSCRIPTIONS_SUPPORT_MESSAGE(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1288
  // Closed captions/subtitles are available for every language we offer! 
  // 
  // On the mobile app:
  // 1. Start a practice  
  // 2. Tap the screen, and then take the <b>Gear icon</b>.  Toggle <b>Show Subtitles</b> to the <b>ON</b> position
  // 
  // On the web app:
  // 1. Start a practice  
  // 2. Click the <b>cc</b> icon located at the bottom right of your screen to turn on the transcriptions
  // 
  // To turn the transcriptions off, just tap <b>cc</b> again.
  val SUBTITLES_ANSWER get() = languageStringFile.SUBTITLES_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1287
  // Do you have closed captions/subtitles?
  val SUBTITLES_QUESTION get() = languageStringFile.SUBTITLES_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=452
  // Success
  val SUCCESS get() = languageStringFile.SUCCESS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1509
  // Sunday
  val SUNDAY get() = languageStringFile.SUNDAY
  
  // https://worker.downdogapp.com/debug/appString?appStringId=500
  // Support
  val SUPPORT get() = languageStringFile.SUPPORT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2333
  // We are a very small company, and get thousands of messages per day, so we can't promise a response, but we'll do our best to get back to you promptly!  Note that we prioritize messages from paying customers.
  val SUPPORT_MANAGE_EXPECTATIONS_TEXT get() = languageStringFile.SUPPORT_MANAGE_EXPECTATIONS_TEXT
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1754
  // Swipe down to start practicing
  val SWIPE_DOWN_TO_START_PRACTICING get() = languageStringFile.SWIPE_DOWN_TO_START_PRACTICING
  
  // https://worker.downdogapp.com/debug/appString?appStringId=262
  // Tap to begin
  val TAP_TO_BEGIN get() = languageStringFile.TAP_TO_BEGIN
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1260
  // Tech issues
  val TECH_ISSUES get() = languageStringFile.TECH_ISSUES
  
  // https://worker.downdogapp.com/debug/appString?appStringId=289
  // Terms of Use
  val TERMS_OF_USE get() = languageStringFile.TERMS_OF_USE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=303
  // Thanks
  val THANKS get() = languageStringFile.THANKS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2157
  // Thanks for filling out the survey!
  val THANKS_FOR_FILLING_OUT_THE_SURVEY get() = languageStringFile.THANKS_FOR_FILLING_OUT_THE_SURVEY
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1265
  // Please fill out this field
  val THIS_FORM_FIELD_IS_REQUIRED get() = languageStringFile.THIS_FORM_FIELD_IS_REQUIRED
  
  // https://worker.downdogapp.com/debug/appString?appStringId=615
  // Timeline
  val TIMELINE get() = languageStringFile.TIMELINE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2050
  // Toggle show more settings
  val TOGGLE_SHOW_MORE_SETTINGS get() = languageStringFile.TOGGLE_SHOW_MORE_SETTINGS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2590
  // You have reached the maximum number of simultaneous downloads. Please wait for one to finish and try again.
  val TOO_MANY_DOWNLOADS get() = languageStringFile.TOO_MANY_DOWNLOADS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1248
  // Total Practices
  val TOTAL_PRACTICES get() = languageStringFile.TOTAL_PRACTICES
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1523
  // Total Practices
  val TOTAL_PRACTICES_CAPITALIZED get() = languageStringFile.TOTAL_PRACTICES_CAPITALIZED
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1524
  // Total practices
  val TOTAL_PRACTICES_NOT_CAPITALIZED get() = languageStringFile.TOTAL_PRACTICES_NOT_CAPITALIZED
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1252
  // Total Time
  val TOTAL_TIME get() = languageStringFile.TOTAL_TIME
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1521
  // Total Time
  val TOTAL_TIME_CAPITALIZED get() = languageStringFile.TOTAL_TIME_CAPITALIZED
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1522
  // Total time practiced
  val TOTAL_TIME_NOT_CAPITALIZED get() = languageStringFile.TOTAL_TIME_NOT_CAPITALIZED
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1137
  // Troubleshooting
  val TROUBLESHOOTING get() = languageStringFile.TROUBLESHOOTING
  
  // https://worker.downdogapp.com/debug/appString?appStringId=251
  // Try Again
  val TRY_AGAIN get() = languageStringFile.TRY_AGAIN
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1155
  // You can turn the in-app music off by swiping up the settings view and tapping <b>Music</b>, then tapping <b>None</b> for the music type!  
  //  
  // If you'd like to play your own music, you can do so through other apps on your device.  However, while the audio cues are turned up to max volume by default on phones and tablets, sometimes this isn't enough to overpower the sound coming from Spotify/iTunes/etc.
  //  
  // In those cases, we recommend either using an external speaker to play music, or using the web version (https://www.downdogapp.com/web) on a laptop or desktop, with your music turned down in the background.
  val TURN_OFF_MUSIC_ANSWER get() = languageStringFile.TURN_OFF_MUSIC_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1154
  // I’d prefer to listen to my own music as I practice.  How do I turn off the music completely?
  val TURN_OFF_MUSIC_QUESTION get() = languageStringFile.TURN_OFF_MUSIC_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2088
  // Whoops, we couldn't load the video
  val UNABLE_TO_LOAD_PLAYBACK_URL get() = languageStringFile.UNABLE_TO_LOAD_PLAYBACK_URL
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1276
  // The linked practice is not associated with this account
  val UNABLE_TO_OPEN_LINKED_PRACTICE get() = languageStringFile.UNABLE_TO_OPEN_LINKED_PRACTICE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=998
  // unknown device
  val UNKNOWN_CAST_RECEIVER_NAME get() = languageStringFile.UNKNOWN_CAST_RECEIVER_NAME
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1641
  // Unlink from Apple
  val UNLINK_FROM_APPLE get() = languageStringFile.UNLINK_FROM_APPLE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1642
  // Set a password to unlink from Apple.
  val UNLINK_FROM_APPLE_MESSAGE get() = languageStringFile.UNLINK_FROM_APPLE_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=504
  // Unlink from Facebook
  val UNLINK_FROM_FACEBOOK get() = languageStringFile.UNLINK_FROM_FACEBOOK
  
  // https://worker.downdogapp.com/debug/appString?appStringId=506
  // Set a password to unlink from Facebook.
  val UNLINK_FROM_FACEBOOK_MESSAGE get() = languageStringFile.UNLINK_FROM_FACEBOOK_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=505
  // Unlink from Google
  val UNLINK_FROM_GOOGLE get() = languageStringFile.UNLINK_FROM_GOOGLE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=507
  // Set a password to unlink from Google.
  val UNLINK_FROM_GOOGLE_MESSAGE get() = languageStringFile.UNLINK_FROM_GOOGLE_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1398
  // 1. Go to <b>Settings</b>. On mobile, you can get there by tapping the three horizontal lines at the bottom right of the screen. On web, Settings is in the left sidebar. 
  // 2. Under <b>Account</b>, tap <b>Unlink from Google</b> (or <b>Unlink from Facebook</b>) and fill in the new password you'd like to use in the Password and Confirm Password fields 
  // 3. Tap <b>Save</b>
  val UNLINK_GOOGLE_FACEBOOK_ANSWER get() = languageStringFile.UNLINK_GOOGLE_FACEBOOK_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1397
  // How can I unlink Google/Facebook, and use an email and password instead?
  val UNLINK_GOOGLE_FACEBOOK_QUESTION get() = languageStringFile.UNLINK_GOOGLE_FACEBOOK_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=418
  // Update
  val UPDATE get() = languageStringFile.UPDATE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1226
  // If your entire practice is flipped, check to make sure you don't have the mirroring function turned on! Here’s how to check!
  // 
  // On the mobile app:
  // 1. Start a practice
  // 2. At the top right of your screen, tap the <b>Gear icon</b>.  Toggle <b>Mirror Video</b> to on or off to flip the display 
  // 
  // On the web app:
  // 1. Start a practice
  // 2. At the bottom right of your screen, click the <b>third icon from the left</b> to flip the display
  // 
  val VIDEO_ACCIDENTALLY_MIRRORED_ANSWER get() = languageStringFile.VIDEO_ACCIDENTALLY_MIRRORED_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1216
  // The video is reversed from what the voice is telling me.
  val VIDEO_ACCIDENTALLY_MIRRORED_QUESTION get() = languageStringFile.VIDEO_ACCIDENTALLY_MIRRORED_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1225
  // Here are a few things you can try:
  // 
  // 1. Uninstall and reinstall the app
  // 
  // 2. Switch to lower quality video. Start a practice, then pause it. Tap on the <b>Gear icon</b> in the upper right corner. Tap <b>Video Quality</b>. You should see options for higher and lower quality video. This setting is only available on the yoga apps.
  // 
  // 3. Web only: Try a different browser. Down Dog works best with Safari, Firefox, and Chrome. 
  val VIDEO_FREEZING_ANSWER get() = languageStringFile.VIDEO_FREEZING_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1215
  // My screen froze midway through the practice.
  val VIDEO_FREEZING_QUESTION get() = languageStringFile.VIDEO_FREEZING_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1201
  // <b>Yoga, Prenatal, Barre</b>
  // 
  // Currently we only have one model for each of our apps.  As we continue to grow, we’d love to be able to add more choices for you!
  // 
  // <b>HIIT</b>
  // 
  // Currently we offer two models in the HIIT app!
  val VIDEO_MODEL_ANSWER get() = languageStringFile.VIDEO_MODEL_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1190
  // Is there more than one model I can watch on the video?
  val VIDEO_MODEL_QUESTION get() = languageStringFile.VIDEO_MODEL_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=670
  // Video Quality
  val VIDEO_QUALITY get() = languageStringFile.VIDEO_QUALITY
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2558
  // View Offline Practice
  val VIEW_OFFLINE_PRACTICE get() = languageStringFile.VIEW_OFFLINE_PRACTICE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1491
  // After completing a practice, or from a practice on your <b>History</b> page, tap <b>Song List</b> to see a playlist of the songs that played during your practice!
  val VIEW_PLAYLIST_ANSWER get() = languageStringFile.VIEW_PLAYLIST_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1490
  // What songs played during my practice?
  val VIEW_PLAYLIST_QUESTION get() = languageStringFile.VIEW_PLAYLIST_QUESTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3109
  // View Poses
  val VIEW_POSES get() = languageStringFile.VIEW_POSES
  
  // https://worker.downdogapp.com/debug/appString?appStringId=75
  // It doesn't look like you're connected to the internet. Please reconnect in order to change visual types.
  val VISUAL_TYPE_NO_INTERNET_MESSAGE get() = languageStringFile.VISUAL_TYPE_NO_INTERNET_MESSAGE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=290
  // Voice
  val VOICE get() = languageStringFile.VOICE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2159
  // We're adding new voice actors to the app and we want your input! Tell us how you like each of the voices below by scoring them from 1 to 5. Please ignore any technical/sound quality issues and focus on their actual voice and how natural the translation sounds!
  val VOICE_ACTOR_NON_ENGLISH_SURVEY_INTRO get() = languageStringFile.VOICE_ACTOR_NON_ENGLISH_SURVEY_INTRO
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2154
  // We're adding new voice actors to the app and we want your input! Tell us how you like each of the voices below by scoring them from 1 to 5. Please ignore any technical/sound quality issues and focus on their actual voice!
  val VOICE_ACTOR_SURVEY_INTRO get() = languageStringFile.VOICE_ACTOR_SURVEY_INTRO
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1423
  // Would you like this payment refunded? Your subscription will be cancelled and you will immediately lose access.
  val WANT_REFUND_CONFIRMATION get() = languageStringFile.WANT_REFUND_CONFIRMATION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1508
  // When should your week start?
  val WEEK_START_TITLE get() = languageStringFile.WEEK_START_TITLE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1518
  // Weekly Goal
  val WEEKLY_GOAL get() = languageStringFile.WEEKLY_GOAL
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1504
  // Set a weekly goal
  val WEEKLY_GOAL_SELECTOR_TITLE get() = languageStringFile.WEEKLY_GOAL_SELECTOR_TITLE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1505
  // How many practices will you aim to do each week?
  val WEEKLY_GOAL_SUBTITLE get() = languageStringFile.WEEKLY_GOAL_SUBTITLE
  
  // https://worker.downdogapp.com/debug/appString?appStringId=569
  // What's up?
  val WHATS_UP get() = languageStringFile.WHATS_UP
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1256
  // {1}% Complete
  fun X_PERCENT_COMPLETE(p0: Any) = languageStringFile.X_PERCENT_COMPLETE(p0)
  
  // https://worker.downdogapp.com/debug/appString?appStringId=378
  // yearly
  val YEARLY get() = languageStringFile.YEARLY
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1289
  // Yearly
  val YEARLY_CAPITALIZED get() = languageStringFile.YEARLY_CAPITALIZED
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1731
  // Yes, Sign Up
  val YES_SIGN_UP get() = languageStringFile.YES_SIGN_UP
  
  // https://worker.downdogapp.com/debug/appString?appStringId=291
  // Yes
  val YES_STRING get() = languageStringFile.YES_STRING
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1060
  // Yoga
  val YOGA get() = languageStringFile.YOGA
  
  // https://worker.downdogapp.com/debug/appString?appStringId=501
  // Yoga for Beginners
  val YOGA_FOR_BEGINNERS get() = languageStringFile.YOGA_FOR_BEGINNERS
  
  // https://worker.downdogapp.com/debug/appString?appStringId=757
  // Down Dog Yoga Practice
  val YOGA_GOOGLE_FIT_DESCRIPTION get() = languageStringFile.YOGA_GOOGLE_FIT_DESCRIPTION
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1493
  // Yoga Nidra is a deeply relaxing guided meditation. In the main yoga app, you can find it under Practice <b>Type</b>.  
  // 
  // Note:  <b>Yoga Nidra is audio only</b> - there will be no video.  
  // 
  // A lot of people enjoy setting the <b>Music</b> to Nature Sounds, Ambient, Brain Waves or Piano and Strings in the app. Try out a few and see which one you prefer!
  // 
  // If you're new to Yoga Nidra, we recommend listening to it with <b>Instruction Type</b> set to <b>Full Explanation</b> or <b>Default</b>. 
  // 
  // You can also use Yoga Nidra to fall asleep! After selecting Yoga Nidra as your practice Type, go to <b>Boost</b> and set your boost to <b>Sleep</b>!
  val YOGA_NIDRA_INFO_ANSWER get() = languageStringFile.YOGA_NIDRA_INFO_ANSWER
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1492
  // What is Yoga Nidra?
  val YOGA_NIDRA_INFO_QUESTION get() = languageStringFile.YOGA_NIDRA_INFO_QUESTION
}

fun get() = Strings
